// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file github.com/pomerium/pomerium/pkg/grpc/config/config.proto (package pomerium.config, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration, FieldMask, ListValue, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import { file_openapiv3_annotations } from "../../../../../../openapiv3/annotations_pb";
import { file_options } from "../../../../../../options_pb";
import { file_validate_validate } from "../../../../../../validate/validate_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file github.com/pomerium/pomerium/pkg/grpc/config/config.proto.
 */
export const file_github_com_pomerium_pomerium_pkg_grpc_config_config: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_duration, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_openapiv3_annotations, file_options, file_validate_validate]);

/**
 * A bundle of Pomerium configuration including routes and settings.
 *
 * @generated from message pomerium.config.Config
 */
export type Config = Message<"pomerium.config.Config"> & {
  /**
   * The name of the configuration.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * All of the routes in the configuration bundle.
   *
   * @generated from field: repeated pomerium.config.Route routes = 2;
   */
  routes: Route[];

  /**
   * All of the settings for the configuration bundle.
   *
   * @generated from field: pomerium.config.Settings settings = 3;
   */
  settings?: Settings | undefined;
};

/**
 * Describes the message pomerium.config.Config.
 * Use `create(ConfigSchema)` to create a new message.
 */
export const ConfigSchema: GenMessage<Config> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 0);

/**
 * A Config along with versioning conditions for when it should be applied.
 *
 * @generated from message pomerium.config.VersionedConfig
 */
export type VersionedConfig = Message<"pomerium.config.VersionedConfig"> & {
  /**
   * The Config that will be applied if the versioning conditions are met.
   *
   * @generated from field: pomerium.config.Config config = 1;
   */
  config?: Config | undefined;

  /**
   * List of conditions that must hold in order to apply this config.
   *
   * @generated from field: repeated pomerium.config.VersionedConfig.Condition conditions = 2;
   */
  conditions: VersionedConfig_Condition[];
};

/**
 * Describes the message pomerium.config.VersionedConfig.
 * Use `create(VersionedConfigSchema)` to create a new message.
 */
export const VersionedConfigSchema: GenMessage<VersionedConfig> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 1);

/**
 * @generated from message pomerium.config.VersionedConfig.Condition
 */
export type VersionedConfig_Condition = Message<"pomerium.config.VersionedConfig.Condition"> & {
  /**
   * Feature gate version to check, or unset to check overall version.
   *
   * @generated from field: optional string feature = 1;
   */
  feature?: string | undefined;

  /**
   * If set: specifies a minimum feature version (inclusive).
   *
   * @generated from field: optional string at_least = 2;
   */
  atLeast?: string | undefined;

  /**
   * If set: specifies a maximum feature version (exclusive).
   *
   * @generated from field: optional string less_than = 3;
   */
  lessThan?: string | undefined;
};

/**
 * Describes the message pomerium.config.VersionedConfig.Condition.
 * Use `create(VersionedConfig_ConditionSchema)` to create a new message.
 */
export const VersionedConfig_ConditionSchema: GenMessage<VersionedConfig_Condition> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 1, 0);

/**
 * A rewrite rule applied to a single response header before the response is
 * returned to the downstream client.
 *
 * @generated from message pomerium.config.RouteRewriteHeader
 */
export type RouteRewriteHeader = Message<"pomerium.config.RouteRewriteHeader"> & {
  /**
   * The name of the response header to rewrite (case-insensitive).
   *
   * @generated from field: string header = 1;
   */
  header: string;

  /**
   * @generated from oneof pomerium.config.RouteRewriteHeader.matcher
   */
  matcher: {
    /**
     * Only the portion of the header value that begins with this literal
     * prefix is replaced; the remainder is kept.
     *
     * @generated from field: string prefix = 3;
     */
    value: string;
    case: "prefix";
  } | { case: undefined; value?: undefined };

  /**
   * The new value (or replacement substring, when `prefix` is set) to write
   * back to the header.
   *
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message pomerium.config.RouteRewriteHeader.
 * Use `create(RouteRewriteHeaderSchema)` to create a new message.
 */
export const RouteRewriteHeaderSchema: GenMessage<RouteRewriteHeader> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 2);

/**
 * Configuration for a route that redirects to a new URL.
 *
 * @generated from message pomerium.config.RouteRedirect
 */
export type RouteRedirect = Message<"pomerium.config.RouteRedirect"> & {
  /**
   * Indicates that the incoming scheme of a request will be swapped with
   * "https".
   *
   * @generated from field: optional bool https_redirect = 1;
   */
  httpsRedirect?: boolean | undefined;

  /**
   * Indicates that the incoming scheme of a request will be swapped with
   * the given value.
   *
   * @generated from field: optional string scheme_redirect = 2;
   */
  schemeRedirect?: string | undefined;

  /**
   * Indicates that the incoming host of a request will be swapped with
   * the given value.
   *
   * @generated from field: optional string host_redirect = 3;
   */
  hostRedirect?: string | undefined;

  /**
   * Indicates that the incoming port of a request will be swapped with
   * the given value.
   *
   * @generated from field: optional uint32 port_redirect = 4;
   */
  portRedirect?: number | undefined;

  /**
   * Indicates that the incoming path portion of a request URL will be
   * swapped with the given value.
   *
   * @generated from field: optional string path_redirect = 5;
   */
  pathRedirect?: string | undefined;

  /**
   * Indicates that the incoming matched path prefix portion of a request
   * URL will be swapped with the given value.
   *
   * @generated from field: optional string prefix_rewrite = 6;
   */
  prefixRewrite?: string | undefined;

  /**
   * The response code used for the redirect. Defaults to 301.
   *
   * @generated from field: optional int32 response_code = 7;
   */
  responseCode?: number | undefined;

  /**
   * Indicates that during redirection, the query portion of the URL will
   * be removed. Defaults to false.
   *
   * @generated from field: optional bool strip_query = 8;
   */
  stripQuery?: boolean | undefined;
};

/**
 * Describes the message pomerium.config.RouteRedirect.
 * Use `create(RouteRedirectSchema)` to create a new message.
 */
export const RouteRedirectSchema: GenMessage<RouteRedirect> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 3);

/**
 * Configuration for a route direct response.
 *
 * @generated from message pomerium.config.RouteDirectResponse
 */
export type RouteDirectResponse = Message<"pomerium.config.RouteDirectResponse"> & {
  /**
   * The status code that Pomerium returns for a static HTTP response.
   * For example, 200.
   *
   * @generated from field: uint32 status = 1;
   */
  status: number;

  /**
   * The response body that Pomerium returns for a static HTTP
   * response.
   *
   * @generated from field: string body = 2;
   */
  body: string;
};

/**
 * Describes the message pomerium.config.RouteDirectResponse.
 * Use `create(RouteDirectResponseSchema)` to create a new message.
 */
export const RouteDirectResponseSchema: GenMessage<RouteDirectResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 4);

/**
 * CircuitBreakerThresholds defines CircuitBreaker settings.
 *
 * @generated from message pomerium.config.CircuitBreakerThresholds
 */
export type CircuitBreakerThresholds = Message<"pomerium.config.CircuitBreakerThresholds"> & {
  /**
   * The maximum number of connections that Envoy will make to the upstream
   * cluster. If not specified, the default is 1024.
   *
   * @generated from field: optional uint32 max_connections = 1;
   */
  maxConnections?: number | undefined;

  /**
   * The maximum number of pending requests that Envoy will allow to the
   * upstream cluster. If not specified, the default is 1024. This limit is
   * applied as a connection limit for non-HTTP traffic.
   *
   * @generated from field: optional uint32 max_pending_requests = 2;
   */
  maxPendingRequests?: number | undefined;

  /**
   * The maximum number of parallel requests that Envoy will make to the
   * upstream cluster. If not specified, the default is 1024. This limit does
   * not apply to non-HTTP traffic.
   *
   * @generated from field: optional uint32 max_requests = 3;
   */
  maxRequests?: number | undefined;

  /**
   * The maximum number of parallel retries that Envoy will allow to the
   * upstream cluster. If not specified, the default is 3.
   *
   * @generated from field: optional uint32 max_retries = 4;
   */
  maxRetries?: number | undefined;

  /**
   * The maximum number of connection pools per cluster that Envoy will
   * concurrently support at once. If not specified, the default is unlimited.
   * Set this for clusters which create a large number of connection pools.
   *
   * @generated from field: optional uint32 max_connection_pools = 5;
   */
  maxConnectionPools?: number | undefined;
};

/**
 * Describes the message pomerium.config.CircuitBreakerThresholds.
 * Use `create(CircuitBreakerThresholdsSchema)` to create a new message.
 */
export const CircuitBreakerThresholdsSchema: GenMessage<CircuitBreakerThresholds> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 5);

/**
 * EntityInfo is the basic metadata for an entity.
 *
 * @generated from message pomerium.config.EntityInfo
 */
export type EntityInfo = Message<"pomerium.config.EntityInfo"> & {
  /**
   * The ID of the entity.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * The name of the entity.
   *
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * When the entity was last modified.
   *
   * @generated from field: optional google.protobuf.Timestamp modified_at = 3;
   */
  modifiedAt?: Timestamp | undefined;
};

/**
 * Describes the message pomerium.config.EntityInfo.
 * Use `create(EntityInfoSchema)` to create a new message.
 */
export const EntityInfoSchema: GenMessage<EntityInfo> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 6);

/**
 * SessionRecording defines session recording settings for routes.
 *
 * @generated from message pomerium.config.SessionRecording
 */
export type SessionRecording = Message<"pomerium.config.SessionRecording"> & {
  /**
   * Toggle to enable/disable recording for this route.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message pomerium.config.SessionRecording.
 * Use `create(SessionRecordingSchema)` to create a new message.
 */
export const SessionRecordingSchema: GenMessage<SessionRecording> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 7);

/**
 * Configuration for a route.
 *
 * @generated from message pomerium.config.Route
 */
export type Route = Message<"pomerium.config.Route"> & {
  /**
   * The id of the route.
   *
   * @generated from field: optional string id = 28;
   */
  id?: string | undefined;

  /**
   * The namespace id of the route.
   *
   * @generated from field: optional string namespace_id = 80;
   */
  namespaceId?: string | undefined;

  /**
   * The originator id of the route.
   *
   * @generated from field: optional string originator_id = 81;
   */
  originatorId?: string | undefined;

  /**
   * The name of the route.
   *
   * @generated from field: optional string name = 1;
   */
  name?: string | undefined;

  /**
   * The name used for stats telemetry with the route.
   *
   * @generated from field: optional string stat_name = 75;
   */
  statName?: string | undefined;

  /**
   * A human-readable description of the route.
   *
   * @generated from field: optional string description = 67;
   */
  description?: string | undefined;

  /**
   * A URL for a logo for the route.
   *
   * @generated from field: optional string logo_url = 68;
   */
  logoUrl?: string | undefined;

  /**
   * The externally accessible URL for a proxied HTTP request.
   *
   * @generated from field: string from = 2;
   */
  from: string;

  /**
   * The destination(s) of a proxied request.
   *
   * @generated from field: repeated string to = 3;
   */
  to: string[];

  /**
   * Indicates that a route should be redirected.
   *
   * @generated from field: pomerium.config.RouteRedirect redirect = 34;
   */
  redirect?: RouteRedirect | undefined;

  /**
   * Indicates that a route should return a direct response.
   *
   * @generated from field: pomerium.config.RouteDirectResponse response = 62;
   */
  response?: RouteDirectResponse | undefined;

  /**
   * Optional load balancing weights for upstream servers defined in to.
   * If not specified, all upstream servers are assigned the same weight.
   * If provided, len(to) must equal len(load_balancing_weights).
   *
   * @generated from field: repeated uint32 load_balancing_weights = 37;
   */
  loadBalancingWeights: number[];

  /**
   * Grants access to the route if the logged-in user's ID matches one of the
   * given values. Deprecated in favor of the PPL user criterion.
   *
   * @generated from field: repeated string allowed_users = 4 [deprecated = true];
   * @deprecated
   */
  allowedUsers: string[];

  /**
   * Grants access to the route if the logged-in user's email address is for
   * one of the given values. Deprecated in favor of the PPL domain criterion.
   *
   * @generated from field: repeated string allowed_domains = 6 [deprecated = true];
   * @deprecated
   */
  allowedDomains: string[];

  /**
   * Grants access to the route if the logged-in user's session/user claims
   * match one of the given values. Deprecated in favor of the PPL claim
   * criterion.
   *
   * @generated from field: map<string, google.protobuf.ListValue> allowed_idp_claims = 32 [deprecated = true];
   * @deprecated
   */
  allowedIdpClaims: { [key: string]: ListValue };

  /**
   * Only match requests that have a path that begins with the given prefix.
   *
   * @generated from field: string prefix = 7;
   */
  prefix: string;

  /**
   * Only match requests whose path is an exact match for the given path.
   *
   * @generated from field: string path = 8;
   */
  path: string;

  /**
   * Only match requests whose path matches the given regular expression.
   *
   * @generated from field: string regex = 9;
   */
  regex: string;

  /**
   * Indicates that when a request is forwarded, the matched prefix (or path)
   * will be swapped with this value.
   *
   * @generated from field: string prefix_rewrite = 29;
   */
  prefixRewrite: string;

  /**
   * A regular expression used to rewrite the path of a forwarded request.
   *
   * @generated from field: string regex_rewrite_pattern = 30;
   */
  regexRewritePattern: string;

  /**
   * When a regular expression pattern is set, what the matched pattern will
   * be replaced with.
   *
   * @generated from field: string regex_rewrite_substitution = 31;
   */
  regexRewriteSubstitution: string;

  /**
   * Determines the ordering of routes that use regular expressions.
   *
   * @generated from field: optional int64 regex_priority_order = 61;
   */
  regexPriorityOrder?: bigint | undefined;

  /**
   * Indicates that OPTIONS requests used for CORS can pass through
   * unauthenticated.
   *
   * @generated from field: bool cors_allow_preflight = 10;
   */
  corsAllowPreflight: boolean;

  /**
   * Grants access to a route without requiring any authentication.
   *
   * @generated from field: bool allow_public_unauthenticated_access = 11;
   */
  allowPublicUnauthenticatedAccess: boolean;

  /**
   * Grants access to a route for any logged-in user.
   *
   * @generated from field: bool allow_any_authenticated_user = 33;
   */
  allowAnyAuthenticatedUser: boolean;

  /**
   * The per-route request timeout option. Cannot exceed global values.
   *
   * @generated from field: google.protobuf.Duration timeout = 12;
   */
  timeout?: Duration | undefined;

  /**
   * The per-route request timeout for a connection that is idle with
   * no data exchange.
   *
   * @generated from field: google.protobuf.Duration idle_timeout = 43;
   */
  idleTimeout?: Duration | undefined;

  /**
   * Allow websocket requests. Also disables the default route timeout.
   *
   * @generated from field: bool allow_websockets = 13;
   */
  allowWebsockets: boolean;

  /**
   * Allow SPDY protocol upgrade requests.
   *
   * @generated from field: bool allow_spdy = 44;
   */
  allowSpdy: boolean;

  /**
   * Indicates that pomerium should perform no verification on upstream
   * TLS connections. Any certificate for any hostname will be accepted.
   *
   * @generated from field: bool tls_skip_verify = 14;
   */
  tlsSkipVerify: boolean;

  /**
   * The server name indication (SNI) for upstream TLS connections. If
   * both tls_server_name and tls_upstream_server_name are set,
   * tls_upstream_server_name will take precedence.
   *
   * @generated from field: string tls_server_name = 15 [deprecated = true];
   * @deprecated
   */
  tlsServerName: string;

  /**
   * The server name indication (SNI) for upstream TLS connections. If
   * both tls_server_name and tls_upstream_server_name are set,
   * tls_upstream_server_name will take precedence.
   *
   * @generated from field: string tls_upstream_server_name = 57;
   */
  tlsUpstreamServerName: string;

  /**
   * The server name indication (SNI) for downstream TLS connections.
   *
   * @generated from field: string tls_downstream_server_name = 58;
   */
  tlsDownstreamServerName: string;

  /**
   * The root certificate authorities (in PEM format) used to verify
   * certificates of upstream TLS connections.
   *
   * @generated from field: string tls_custom_ca = 16;
   */
  tlsCustomCa: string;

  /**
   * A file containing root certificate authorities (in PEM format)
   * used to verify certificates of upstream TLS connections.
   *
   * @generated from field: string tls_custom_ca_file = 17;
   */
  tlsCustomCaFile: string;

  /**
   * A reference to a key pair containing root certificate authorities (in PEM
   * format) used to verify certificates of upstream TLS connections.
   *
   * @generated from field: optional string tls_custom_ca_key_pair_id = 82;
   */
  tlsCustomCaKeyPairId?: string | undefined;

  /**
   * The client certificate to present to upstream TLS connections for
   * mTLS.
   *
   * @generated from field: string tls_client_cert = 18;
   */
  tlsClientCert: string;

  /**
   * The private key for the client certificate to present to upstream
   * TLS connections for mTLS.
   *
   * @generated from field: string tls_client_key = 19;
   */
  tlsClientKey: string;

  /**
   * A file containing the client certificate to present to upstream TLS
   * connections for mTLS.
   *
   * @generated from field: string tls_client_cert_file = 20;
   */
  tlsClientCertFile: string;

  /**
   * A file containing the private key for the client certificate to
   * present to upstream TLS connections for mTLS.
   *
   * @generated from field: string tls_client_key_file = 21;
   */
  tlsClientKeyFile: string;

  /**
   * A reference to the key pair containing the client certificate
   * and private key to present to upstream TLS connections for mTLS.
   *
   * @generated from field: optional string tls_client_key_pair_id = 83;
   */
  tlsClientKeyPairId?: string | undefined;

  /**
   * The root certificate authorities (in PEM format) used to verify
   * certificates for downstream TLS connections. If specified
   * downstream clients will be required to provide a valid client TLS
   * certificate.
   *
   * @generated from field: string tls_downstream_client_ca = 38 [deprecated = true];
   * @deprecated
   */
  tlsDownstreamClientCa: string;

  /**
   * A file containing the root certificate authorities (in PEM format) used to
   * verify certificates for downstream TLS connections. If specified
   * downstream clients will be required to provide a valid client TLS
   * certificate.
   *
   * @generated from field: string tls_downstream_client_ca_file = 39 [deprecated = true];
   * @deprecated
   */
  tlsDownstreamClientCaFile: string;

  /**
   * A reference to a key pair containing the root certificate authorities (in
   * PEM format) used to verify certificates for downstream TLS connections. If
   * specified downstream clients will be required to provide a valid client TLS
   * certificate.
   *
   * @generated from field: optional string tls_downstream_client_ca_key_pair_id = 84 [deprecated = true];
   * @deprecated
   */
  tlsDownstreamClientCaKeyPairId?: string | undefined;

  /**
   * Controls whether server-initiated TLS renegotiation is allowed for
   * upstream servers.
   *
   * @generated from field: bool tls_upstream_allow_renegotiation = 60;
   */
  tlsUpstreamAllowRenegotiation: boolean;

  /**
   * Allows you to set both static and dynamic headers for upstream requests.
   * Static values can be useful if you want to pass along additional
   * information to upstream applications as headers, or to set a fixed
   * authentication header on the request. Dynamic values enable you to pass
   * ID and Access tokens from your identity provider to upstream
   * applications. The following dynamic header values are supported:
   *
   * - ${pomerium.access_token}: OAuth access token from the identity provider.
   * - ${pomerium.client_cert_fingerprint}: Short-form SHA-256 fingerprint of the presented client certificate.
   * - ${pomerium.id_token}: OIDC ID token from the identity provider.
   * - ${pomerium.jwt}: The Pomerium assertion JWT for the logged-in user.
   *
   * @generated from field: map<string, string> set_request_headers = 22;
   */
  setRequestHeaders: { [key: string]: string };

  /**
   * Headers to remove from upstream requests. This can be useful if you want to
   * prevent privacy information from being passed to upstream applications.
   *
   * @generated from field: repeated string remove_request_headers = 23;
   */
  removeRequestHeaders: string[];

  /**
   * Allows you to set static values for the given downstream response headers.
   * These headers will take precedence over the global set_response_headers.
   *
   * @generated from field: map<string, string> set_response_headers = 41;
   */
  setResponseHeaders: { [key: string]: string };

  /**
   * Used to modify downstream response headers.
   *
   * @generated from field: repeated pomerium.config.RouteRewriteHeader rewrite_response_headers = 40;
   */
  rewriteResponseHeaders: RouteRewriteHeader[];

  /**
   * Passes the Host (or :authority) header from the incoming request to the
   * upstream service, instead of the Host header from the route's to URL.
   *
   * @generated from field: bool preserve_host_header = 24;
   */
  preserveHostHeader: boolean;

  /**
   * Sends identity headers to all upstream applications. Identity headers
   * include:
   *
   * - X-Pomerium-Jwt-Assertion: The pomerium assertion JWT for the logged-in user.
   * - X-Pomerium-Claim-*: Each of the claim values specified by the jwt_claim_headers option.
   *
   * When not set explicitly, the global pass_identity_headers option will be used.
   *
   * @generated from field: optional bool pass_identity_headers = 25;
   */
  passIdentityHeaders?: boolean | undefined;

  /**
   * A Kubernetes service account token used to authenticate to the
   * Kubernetes API via Authorization: Bearer and Impersonate-User/Group
   * headers.
   *
   * @generated from field: string kubernetes_service_account_token = 26;
   */
  kubernetesServiceAccountToken: string;

  /**
   * A file containing a Kubernetes service account token.
   *
   * @generated from field: string kubernetes_service_account_token_file = 64;
   */
  kubernetesServiceAccountTokenFile: string;

  /**
   * A key pair reference for a Kubernetes service account token.
   *
   * @generated from field: optional string kubernetes_service_account_token_key_pair_id = 85;
   */
  kubernetesServiceAccountTokenKeyPairId?: string | undefined;

  /**
   * Adds an Authorization: Bearer ID_TOKEN header for Google Cloud
   * serverless upstream requests.
   *
   * @generated from field: bool enable_google_cloud_serverless_authentication = 42;
   */
  enableGoogleCloudServerlessAuthentication: boolean;

  /**
   * Controls the format of the iss claim in JWTs passed to upstream
   * services by this route.
   *
   * @generated from field: optional pomerium.config.IssuerFormat jwt_issuer_format = 65;
   */
  jwtIssuerFormat?: IssuerFormat | undefined;

  /**
   * Allowlist of group names or IDs to include in the Pomerium JWT for
   * this route.
   *
   * @generated from field: repeated string jwt_groups_filter = 66;
   */
  jwtGroupsFilter: string[];

  /**
   * Whether to add JWT groups from any PPL policies.
   * Not supported in the open source version of Pomerium.
   *
   * @generated from field: optional bool jwt_groups_filter_infer_from_ppl = 89;
   */
  jwtGroupsFilterInferFromPpl?: boolean | undefined;

  /**
   * Controls how authorization bearer tokens are interpreted for this
   * route. When unset, the global bearer_token_format option is used.
   *
   * @generated from field: optional pomerium.config.BearerTokenFormat bearer_token_format = 70;
   */
  bearerTokenFormat?: BearerTokenFormat | undefined;

  /**
   * Additional hosts that participate in chained login redirects for
   * this route. Up to five hosts are supported.
   *
   * @generated from field: repeated string depends_on = 71;
   */
  dependsOn: string[];

  /**
   * Structured sub-policies attached to this route.
   *
   * @generated from field: repeated pomerium.config.Policy policies = 27;
   */
  policies: Policy[];

  /**
   * PPL policies attached to this route.
   *
   * @generated from field: repeated pomerium.config.PPLPolicy ppl_policies = 63;
   */
  pplPolicies: PPLPolicy[];

  /**
   * IDs of policies assigned to this route.
   *
   * @generated from field: repeated string policy_ids = 86;
   */
  policyIds: string[];

  /**
   * Rewrites the Host or :authority header to a fixed value.
   *
   * @generated from field: optional string host_rewrite = 50;
   */
  hostRewrite?: string | undefined;

  /**
   * Rewrites the Host or :authority header using the value of another
   * request header.
   *
   * @generated from field: optional string host_rewrite_header = 51;
   */
  hostRewriteHeader?: string | undefined;

  /**
   * A regular expression used to rewrite the Host or :authority header
   * from the request path.
   *
   * @generated from field: optional string host_path_regex_rewrite_pattern = 52;
   */
  hostPathRegexRewritePattern?: string | undefined;

  /**
   * When host_path_regex_rewrite_pattern is set, what the matched
   * pattern will be replaced with to produce the Host header.
   *
   * @generated from field: optional string host_path_regex_rewrite_substitution = 53;
   */
  hostPathRegexRewriteSubstitution?: string | undefined;

  /**
   * Overrides the global identity provider client ID for this route.
   *
   * @generated from field: optional string idp_client_id = 55;
   */
  idpClientId?: string | undefined;

  /**
   * Overrides the global identity provider client secret for this route.
   *
   * @generated from field: optional string idp_client_secret = 56;
   */
  idpClientSecret?: string | undefined;

  /**
   * Allowed audiences for validating IdP-issued access tokens for this
   * route.
   *
   * @generated from field: optional pomerium.config.Route.StringList idp_access_token_allowed_audiences = 69;
   */
  idpAccessTokenAllowedAudiences?: Route_StringList | undefined;

  /**
   * If true, include policy explanation and remediation details in
   * authorization error responses.
   *
   * @generated from field: bool show_error_details = 59;
   */
  showErrorDetails: boolean;

  /**
   * Model Context Protocol configuration for this route. Requires the
   * runtime_flags.mcp feature flag.
   *
   * @generated from field: optional pomerium.config.MCP mcp = 72;
   */
  mcp?: MCP | undefined;

  /**
   * Circuit breaker thresholds for upstream requests on this route.
   *
   * @generated from field: optional pomerium.config.CircuitBreakerThresholds circuit_breaker_thresholds = 73;
   */
  circuitBreakerThresholds?: CircuitBreakerThresholds | undefined;

  /**
   * Configuration for reverse tunneling to upstreams for this route.
   *
   * @generated from field: optional pomerium.config.UpstreamTunnel upstream_tunnel = 74;
   */
  upstreamTunnel?: UpstreamTunnel | undefined;

  /**
   * Passive health checking via outlier detection for upstream hosts on
   * this route.
   *
   * @generated from field: optional pomerium.config.OutlierDetection outlier_detection = 76;
   */
  outlierDetection?: OutlierDetection | undefined;

  /**
   * Active health checks to run against upstream hosts for this route.
   *
   * @generated from field: repeated pomerium.config.HealthCheck health_checks = 77;
   */
  healthChecks: HealthCheck[];

  /**
   * The load balancing algorithm for upstream endpoints. Options:
   * ROUND_ROBIN, RING_HASH, LEAST_REQUEST, RANDOM, MAGLEV.
   *
   * @generated from field: optional pomerium.config.LoadBalancingPolicy load_balancing_policy = 78;
   */
  loadBalancingPolicy?: LoadBalancingPolicy | undefined;

  /**
   * If the percentage of healthy upstream hosts drops below this value,
   * traffic will be sent to all hosts regardless of health status.
   *
   * @generated from field: optional int32 healthy_panic_threshold = 79;
   */
  healthyPanicThreshold?: number | undefined;

  /**
   * Allows HTTP upgrade requests to be forwarded upstream.
   *
   * @generated from field: optional pomerium.config.Route.StringList allow_upgrades = 93;
   */
  allowUpgrades?: Route_StringList | undefined;

  /**
   * Configures session recording behaviour on this route.
   * SSH specific.
   *
   * @generated from field: optional pomerium.config.SessionRecording session_recording = 94;
   */
  sessionRecording?: SessionRecording | undefined;

  /**
   * When the route was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 87;
   */
  createdAt?: Timestamp | undefined;

  /**
   * When the route was last modified.
   *
   * @generated from field: google.protobuf.Timestamp modified_at = 88;
   */
  modifiedAt?: Timestamp | undefined;

  /**
   * Policies that are automatically enforced.
   * Not supported in the open source version of Pomerium.
   *
   * @generated from field: repeated pomerium.config.EntityInfo enforced_policies = 90;
   */
  enforcedPolicies: EntityInfo[];

  /**
   * Info about policies assigned to this route.
   * Not supported in the open source version of Pomerium.
   *
   * @generated from field: repeated pomerium.config.EntityInfo assigned_policies = 91;
   */
  assignedPolicies: EntityInfo[];

  /**
   * The name of the namespace for the route.
   *
   * @generated from field: optional string namespace_name = 92;
   */
  namespaceName?: string | undefined;
};

/**
 * Describes the message pomerium.config.Route.
 * Use `create(RouteSchema)` to create a new message.
 */
export const RouteSchema: GenMessage<Route> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 8);

/**
 * Wrapper for a list of strings, used so map-valued fields can hold
 * repeated string values.
 *
 * @generated from message pomerium.config.Route.StringList
 */
export type Route_StringList = Message<"pomerium.config.Route.StringList"> & {
  /**
   * The string values held by this list.
   *
   * @generated from field: repeated string values = 1;
   */
  values: string[];
};

/**
 * Describes the message pomerium.config.Route.StringList.
 * Use `create(Route_StringListSchema)` to create a new message.
 */
export const Route_StringListSchema: GenMessage<Route_StringList> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 8, 0);

/**
 * Configuration for an upstream tunnel. Applies to routes whose upstream is
 * reached through Pomerium's SSH proxy.
 *
 * @generated from message pomerium.config.UpstreamTunnel
 */
export type UpstreamTunnel = Message<"pomerium.config.UpstreamTunnel"> & {
  /**
   * PPL policy enforced before the SSH tunnel is opened to the upstream.
   *
   * @generated from field: optional pomerium.config.PPLPolicy ssh_policy = 1;
   */
  sshPolicy?: PPLPolicy | undefined;

  /**
   * Rego rules evaluated before the SSH tunnel is opened to the upstream.
   *
   * @generated from field: repeated string ssh_policy_rego = 2;
   */
  sshPolicyRego: string[];

  /**
   * ID of a shared policy whose rules also gate this SSH tunnel.
   *
   * @generated from field: optional string ssh_policy_id = 3;
   */
  sshPolicyId?: string | undefined;
};

/**
 * Describes the message pomerium.config.UpstreamTunnel.
 * Use `create(UpstreamTunnelSchema)` to create a new message.
 */
export const UpstreamTunnelSchema: GenMessage<UpstreamTunnel> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 9);

/**
 * Configuration for an MCP route.
 *
 * @generated from message pomerium.config.MCP
 */
export type MCP = Message<"pomerium.config.MCP"> & {
  /**
   * @generated from oneof pomerium.config.MCP.mode
   */
  mode: {
    /**
     * Indicates that this route fronts an MCP server.
     *
     * @generated from field: pomerium.config.MCPServer server = 1;
     */
    value: MCPServer;
    case: "server";
  } | {
    /**
     * Provides an application with external tokens for MCP server access.
     *
     * @generated from field: pomerium.config.MCPClient client = 2;
     */
    value: MCPClient;
    case: "client";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pomerium.config.MCP.
 * Use `create(MCPSchema)` to create a new message.
 */
export const MCPSchema: GenMessage<MCP> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 10);

/**
 * Configuration for an MCP server route.
 *
 * @generated from message pomerium.config.MCPServer
 */
export type MCPServer = Message<"pomerium.config.MCPServer"> & {
  /**
   * Specifies that before the request reaches the MCP upstream server,
   * it should acquire an OAuth2 token.
   *
   * @generated from field: optional pomerium.config.UpstreamOAuth2 upstream_oauth2 = 1;
   */
  upstreamOauth2?: UpstreamOAuth2 | undefined;

  /**
   * The maximum request body size in bytes that can be sent to the MCP
   * server (default: 4KiB).
   *
   * @generated from field: optional uint32 max_request_bytes = 2;
   */
  maxRequestBytes?: number | undefined;

  /**
   * The path to append to the URL when returning the server URL in the
   * .mcp/routes endpoint. Defaults to "/".
   *
   * @generated from field: optional string path = 3;
   */
  path?: string | undefined;

  /**
   * The issuer URL of the upstream authorization server. Used as a fallback
   * when PRM (RFC 9728) discovery fails, per the MCP spec's "abort or use
   * pre-configured values" guidance.
   *
   * @generated from field: optional string authorization_server_url = 4;
   */
  authorizationServerUrl?: string | undefined;
};

/**
 * Describes the message pomerium.config.MCPServer.
 * Use `create(MCPServerSchema)` to create a new message.
 */
export const MCPServerSchema: GenMessage<MCPServer> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 11);

/**
 * Configuration for an MCP client route.
 *
 * @generated from message pomerium.config.MCPClient
 */
export type MCPClient = Message<"pomerium.config.MCPClient"> & {
};

/**
 * Describes the message pomerium.config.MCPClient.
 * Use `create(MCPClientSchema)` to create a new message.
 */
export const MCPClientSchema: GenMessage<MCPClient> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 12);

/**
 * Configuration for OAuth2 authorization for an upstream service behind
 * Pomerium.
 *
 * @generated from message pomerium.config.UpstreamOAuth2
 */
export type UpstreamOAuth2 = Message<"pomerium.config.UpstreamOAuth2"> & {
  /**
   * The public identifier for an application.
   *
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * The secret known only to the application and the authorization server.
   *
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;

  /**
   * The OAuth2 endpoint configuration.
   *
   * @generated from field: pomerium.config.OAuth2Endpoint oauth2_endpoint = 3;
   */
  oauth2Endpoint?: OAuth2Endpoint | undefined;

  /**
   * Scope to control what data the OAuth2 server returns.
   *
   * @generated from field: repeated string scopes = 4;
   */
  scopes: string[];

  /**
   * Additional parameters to add to authorization requests.
   *
   * @generated from field: map<string, string> authorization_url_params = 5;
   */
  authorizationUrlParams: { [key: string]: string };
};

/**
 * Describes the message pomerium.config.UpstreamOAuth2.
 * Use `create(UpstreamOAuth2Schema)` to create a new message.
 */
export const UpstreamOAuth2Schema: GenMessage<UpstreamOAuth2> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 13);

/**
 * Configuration for an OAuth2 server endpoint.
 *
 * @generated from message pomerium.config.OAuth2Endpoint
 */
export type OAuth2Endpoint = Message<"pomerium.config.OAuth2Endpoint"> & {
  /**
   * The authorization URL.
   *
   * @generated from field: string auth_url = 1;
   */
  authUrl: string;

  /**
   * The token URL.
   *
   * @generated from field: string token_url = 2;
   */
  tokenUrl: string;

  /**
   * if unset, auto-detect which authentication
   * style the provider wants by trying both ways and caching
   * the successful way for the future.
   *
   * @generated from field: optional pomerium.config.OAuth2AuthStyle auth_style = 3;
   */
  authStyle?: OAuth2AuthStyle | undefined;
};

/**
 * Describes the message pomerium.config.OAuth2Endpoint.
 * Use `create(OAuth2EndpointSchema)` to create a new message.
 */
export const OAuth2EndpointSchema: GenMessage<OAuth2Endpoint> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 14);

/**
 * A policy expressed in Pomerium Policy Language (PPL).
 *
 * @generated from message pomerium.config.PPLPolicy
 */
export type PPLPolicy = Message<"pomerium.config.PPLPolicy"> & {
  /**
   * The serialized PPL document as raw bytes (typically YAML).
   *
   * @generated from field: bytes raw = 1;
   */
  raw: Uint8Array;
};

/**
 * Describes the message pomerium.config.PPLPolicy.
 * Use `create(PPLPolicySchema)` to create a new message.
 */
export const PPLPolicySchema: GenMessage<PPLPolicy> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 15);

/**
 * Configuration for a policy.
 *
 * @generated from message pomerium.config.Policy
 */
export type Policy = Message<"pomerium.config.Policy"> & {
  /**
   * Server-assigned unique ID of the policy.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * ID of the namespace the policy belongs to.
   *
   * @generated from field: optional string namespace_id = 11;
   */
  namespaceId?: string | undefined;

  /**
   * ID of the upstream object the policy originated from, when imported.
   *
   * @generated from field: optional string originator_id = 12;
   */
  originatorId?: string | undefined;

  /**
   * Human-readable name of the policy.
   *
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * Free-form description of what the policy is for.
   *
   * @generated from field: optional string description = 13;
   */
  description?: string | undefined;

  /**
   * An enforced policy is automatically applied to routes.
   * Not supported in the open source version of Pomerium.
   *
   * @generated from field: optional bool enforced = 14;
   */
  enforced?: boolean | undefined;

  /**
   * Grants access if the logged-in user's ID matches one of the given values.
   *
   * @generated from field: repeated string allowed_users = 3;
   */
  allowedUsers: string[];

  /**
   * Grants access if the logged-in user's email address domain matches one
   * of the given values.
   *
   * @generated from field: repeated string allowed_domains = 5;
   */
  allowedDomains: string[];

  /**
   * Grants access if the logged-in user's IdP claims include one of the
   * listed key/value pairs.
   *
   * @generated from field: map<string, google.protobuf.ListValue> allowed_idp_claims = 7;
   */
  allowedIdpClaims: { [key: string]: ListValue };

  /**
   * Rego rules that authorize requests. All rules must allow for access to
   * be granted.
   *
   * @generated from field: repeated string rego = 6;
   */
  rego: string[];

  /**
   * The original PPL source the policy was compiled from, when available.
   *
   * @generated from field: optional string source_ppl = 10;
   */
  sourcePpl?: string | undefined;

  /**
   * Free-form text shown to the user explaining why this policy applies.
   *
   * @generated from field: optional string explanation = 8;
   */
  explanation?: string | undefined;

  /**
   * Free-form text shown to the user telling them how to gain access when
   * this policy denies the request.
   *
   * @generated from field: optional string remediation = 9;
   */
  remediation?: string | undefined;

  /**
   * When the policy was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */
  createdAt?: Timestamp | undefined;

  /**
   * When the policy was last modified.
   *
   * @generated from field: google.protobuf.Timestamp modified_at = 16;
   */
  modifiedAt?: Timestamp | undefined;

  /**
   * Routes that are automatically enforced by this policy.
   * Not supported in the open source version of Pomerium.
   *
   * @generated from field: repeated pomerium.config.EntityInfo enforced_routes = 17;
   */
  enforcedRoutes: EntityInfo[];

  /**
   * Info about routes with this policy assigned.
   * Not supported in the open source version of Pomerium.
   *
   * @generated from field: repeated pomerium.config.EntityInfo assigned_routes = 18;
   */
  assignedRoutes: EntityInfo[];

  /**
   * The name of the namespace for the policy.
   *
   * @generated from field: optional string namespace_name = 19;
   */
  namespaceName?: string | undefined;
};

/**
 * Describes the message pomerium.config.Policy.
 * Use `create(PolicySchema)` to create a new message.
 */
export const PolicySchema: GenMessage<Policy> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 16);

/**
 * Global Pomerium configuration settings.
 *
 * @generated from message pomerium.config.Settings
 */
export type Settings = Message<"pomerium.config.Settings"> & {
  /**
   * Server-assigned unique ID of the Settings record.
   *
   * @generated from field: optional string id = 158;
   */
  id?: string | undefined;

  /**
   * ID of the namespace the Settings record belongs to.
   *
   * @generated from field: optional string namespace_id = 159;
   */
  namespaceId?: string | undefined;

  /**
   * ID of the cluster the Settings record applies to.
   *
   * @generated from field: optional string cluster_id = 176;
   */
  clusterId?: string | undefined;

  /**
   * ID of the upstream object the record originated from, when imported.
   *
   * @generated from field: optional string originator_id = 160;
   */
  originatorId?: string | undefined;

  /**
   * Human-readable name of the Settings record.
   *
   * @generated from field: optional string name = 161;
   */
  name?: string | undefined;

  /**
   * Stable identifier for this installation, used in telemetry and
   * diagnostics. Generated at first start when unset.
   *
   * @generated from field: optional string installation_id = 71;
   */
  installationId?: string | undefined;

  /**
   * Global log level for Pomerium services ("debug", "info", "warn",
   * "error"). Empty falls back to "info".
   *
   * @generated from field: optional string log_level = 3;
   */
  logLevel?: string | undefined;

  /**
   * Subset of access-log fields to emit. Use
   * ListAvailableLogFields.available_access_log_fields to see what's valid;
   * unset means the service default.
   *
   * @generated from field: optional pomerium.config.Settings.StringList access_log_fields = 114;
   */
  accessLogFields?: Settings_StringList | undefined;

  /**
   * Subset of authorize-log fields to emit; see ListAvailableLogFields.
   *
   * @generated from field: optional pomerium.config.Settings.StringList authorize_log_fields = 115;
   */
  authorizeLogFields?: Settings_StringList | undefined;

  /**
   * Log level for the proxy service in particular, overriding `log_level`.
   *
   * @generated from field: optional string proxy_log_level = 4;
   */
  proxyLogLevel?: string | undefined;

  /**
   * Cluster-wide shared secret used to sign and validate internal requests
   * and JWTs across Pomerium services. Must be a base64-encoded 32-byte
   * value.
   *
   * @generated from field: optional string shared_secret = 5;
   */
  sharedSecret?: string | undefined;

  /**
   * Comma-separated list of Pomerium services to run in this process
   * ("all", "authenticate", "authorize", "databroker", "proxy").
   *
   * @generated from field: optional string services = 6;
   */
  services?: string | undefined;

  /**
   * IP address and port for serving HTTPS requests (e.g. ":443").
   *
   * @generated from field: optional string address = 7;
   */
  address?: string | undefined;

  /**
   * When true, Pomerium serves HTTP without TLS. Intended only for testing
   * behind a TLS-terminating load balancer.
   *
   * @generated from field: optional bool insecure_server = 8;
   */
  insecureServer?: boolean | undefined;

  /**
   * How long Envoy waits before retrying a failed DNS resolution.
   *
   * @generated from field: optional google.protobuf.Duration dns_failure_refresh_rate = 153;
   */
  dnsFailureRefreshRate?: Duration | undefined;

  /**
   * Envoy DNS lookup family ("AUTO", "V4_ONLY", "V6_ONLY", "V4_PREFERRED",
   * "ALL"). Controls which address families Envoy resolves.
   *
   * @generated from field: optional string dns_lookup_family = 60;
   */
  dnsLookupFamily?: string | undefined;

  /**
   * Maximum time Envoy waits for a single DNS query to return.
   *
   * @generated from field: optional google.protobuf.Duration dns_query_timeout = 149;
   */
  dnsQueryTimeout?: Duration | undefined;

  /**
   * Number of times Envoy retries a failed DNS query before giving up.
   *
   * @generated from field: optional uint32 dns_query_tries = 148;
   */
  dnsQueryTries?: number | undefined;

  /**
   * How often Envoy refreshes resolved addresses regardless of TTL.
   *
   * @generated from field: optional google.protobuf.Duration dns_refresh_rate = 154;
   */
  dnsRefreshRate?: Duration | undefined;

  /**
   * Maximum number of in-flight DNS queries Envoy will multiplex over a
   * single UDP socket.
   *
   * @generated from field: optional uint32 dns_udp_max_queries = 146;
   */
  dnsUdpMaxQueries?: number | undefined;

  /**
   * When true, Envoy resolves DNS over TCP instead of UDP.
   *
   * @generated from field: optional bool dns_use_tcp = 147;
   */
  dnsUseTcp?: boolean | undefined;

  /**
   * Inline TLS certificate/key pairs Pomerium serves. Each entry is matched
   * against the request's SNI hostname.
   *
   * @generated from field: repeated pomerium.config.Settings.Certificate certificates = 9;
   */
  certificates: Settings_Certificate[];

  /**
   * IDs of managed key pairs to serve as TLS certificates, as an alternative
   * to inline `certificates` entries.
   *
   * @generated from field: repeated string certificate_key_pair_ids = 162;
   */
  certificateKeyPairIds: string[];

  /**
   * Address (host:port) on which Pomerium listens for plaintext HTTP and
   * issues a redirect to the HTTPS address. Empty disables the redirect
   * listener.
   *
   * @generated from field: optional string http_redirect_addr = 10;
   */
  httpRedirectAddr?: string | undefined;

  /**
   * Maximum time the proxy will wait for a complete request from a
   * downstream client.
   *
   * @generated from field: optional google.protobuf.Duration timeout_read = 11;
   */
  timeoutRead?: Duration | undefined;

  /**
   * Maximum time the proxy will wait to send a complete response to a
   * downstream client.
   *
   * @generated from field: optional google.protobuf.Duration timeout_write = 12;
   */
  timeoutWrite?: Duration | undefined;

  /**
   * Maximum idle time on a kept-alive connection before it is closed.
   *
   * @generated from field: optional google.protobuf.Duration timeout_idle = 13;
   */
  timeoutIdle?: Duration | undefined;

  /**
   * Externally accessible URL for the authenticate service.
   *
   * @generated from field: optional string authenticate_service_url = 14;
   */
  authenticateServiceUrl?: string | undefined;

  /**
   * URL Pomerium uses internally to reach the authenticate service. Set
   * when the externally visible URL goes through a load balancer that
   * proxies cannot reuse.
   *
   * @generated from field: optional string authenticate_internal_service_url = 82;
   */
  authenticateInternalServiceUrl?: string | undefined;

  /**
   * URL to redirect users to after they sign out.
   *
   * @generated from field: optional string signout_redirect_url = 93;
   */
  signoutRedirectUrl?: string | undefined;

  /**
   * Name of the session cookie Pomerium issues. Defaults to "_pomerium".
   *
   * @generated from field: optional string cookie_name = 16;
   */
  cookieName?: string | undefined;

  /**
   * Secret used to encrypt and sign session cookies. Must be a
   * base64-encoded 32-byte value.
   *
   * @generated from field: optional string cookie_secret = 17;
   */
  cookieSecret?: string | undefined;

  /**
   * Domain set on the session cookie. Pomerium defaults to the
   * authenticate service URL host.
   *
   * @generated from field: optional string cookie_domain = 18;
   */
  cookieDomain?: string | undefined;

  /**
   * When true the session cookie carries the HttpOnly attribute.
   *
   * @generated from field: optional bool cookie_http_only = 20;
   */
  cookieHttpOnly?: boolean | undefined;

  /**
   * How long an issued session cookie remains valid.
   *
   * @generated from field: optional google.protobuf.Duration cookie_expire = 21;
   */
  cookieExpire?: Duration | undefined;

  /**
   * SameSite attribute of the session cookie ("strict", "lax", "none").
   *
   * @generated from field: optional string cookie_same_site = 113;
   */
  cookieSameSite?: string | undefined;

  /**
   * OAuth2 client ID for the identity provider.
   *
   * @generated from field: optional string idp_client_id = 22;
   */
  idpClientId?: string | undefined;

  /**
   * OAuth2 client secret for the identity provider.
   *
   * @generated from field: optional string idp_client_secret = 23;
   */
  idpClientSecret?: string | undefined;

  /**
   * Identity provider name ("oidc", "okta", "auth0", "google", "azure", …).
   * Selects which IdP integration Pomerium uses.
   *
   * @generated from field: optional string idp_provider = 24;
   */
  idpProvider?: string | undefined;

  /**
   * OIDC issuer URL of the identity provider.
   *
   * @generated from field: optional string idp_provider_url = 25;
   */
  idpProviderUrl?: string | undefined;

  /**
   * Audiences Pomerium accepts on IdP-issued access tokens. Required when
   * BEARER_TOKEN_FORMAT_IDP_ACCESS_TOKEN routes exist.
   *
   * @generated from field: optional pomerium.config.Settings.StringList idp_access_token_allowed_audiences = 137;
   */
  idpAccessTokenAllowedAudiences?: Settings_StringList | undefined;

  /**
   * OIDC scopes Pomerium requests when authenticating users.
   *
   * @generated from field: repeated string scopes = 26;
   */
  scopes: string[];

  /**
   * Additional query parameters Pomerium appends to the IdP authorization
   * request.
   *
   * @generated from field: map<string, string> request_params = 30;
   */
  requestParams: { [key: string]: string };

  /**
   * Externally accessible URLs for the authorize service.
   *
   * @generated from field: repeated string authorize_service_urls = 32;
   */
  authorizeServiceUrls: string[];

  /**
   * URL Pomerium uses internally to reach the authorize service.
   *
   * @generated from field: optional string authorize_internal_service_url = 83;
   */
  authorizeInternalServiceUrl?: string | undefined;

  /**
   * Hostname Pomerium expects in upstream TLS certificates. Useful when
   * upstream addresses are IPs but the certificate contains a hostname SAN.
   *
   * @generated from field: optional string override_certificate_name = 33;
   */
  overrideCertificateName?: string | undefined;

  /**
   * PEM-encoded certificate authority bundle Pomerium trusts for upstream
   * TLS verification.
   *
   * @generated from field: optional string certificate_authority = 34;
   */
  certificateAuthority?: string | undefined;

  /**
   * ID of a managed key pair whose certificate is used as the upstream CA
   * bundle, as an alternative to the inline `certificate_authority` value.
   *
   * @generated from field: optional string certificate_authority_key_pair_id = 163;
   */
  certificateAuthorityKeyPairId?: string | undefined;

  /**
   * Base hostname Pomerium uses to derive default TLS certificates for
   * routes. Empty disables derivation.
   *
   * @generated from field: optional string derive_tls = 96;
   */
  deriveTls?: string | undefined;

  /**
   * Private key Pomerium uses to sign internally issued JWTs (e.g. the JWT
   * attached to upstream requests). Must be a PEM-encoded key.
   *
   * @generated from field: optional string signing_key = 36;
   */
  signingKey?: string | undefined;

  /**
   * Headers Pomerium sets on every response across all routes.
   *
   * @generated from field: map<string, string> set_response_headers = 69;
   */
  setResponseHeaders: { [key: string]: string };

  /**
   * Map of header name to JWT claim. Pomerium copies the claim value from
   * the session JWT to the named header on upstream requests.
   *
   * @generated from field: map<string, string> jwt_claims_headers = 63;
   */
  jwtClaimsHeaders: { [key: string]: string };

  /**
   * Format of the `iss` claim in JWTs Pomerium issues for upstream
   * requests.
   *
   * @generated from field: optional pomerium.config.IssuerFormat jwt_issuer_format = 139;
   */
  jwtIssuerFormat?: IssuerFormat | undefined;

  /**
   * Allowlist of group IDs/names; the JWT Pomerium issues includes only
   * groups appearing here. Empty means include all.
   *
   * @generated from field: repeated string jwt_groups_filter = 119;
   */
  jwtGroupsFilter: string[];

  /**
   * When true the effective `jwt_groups_filter` is augmented with groups
   * referenced by route PPL policies.
   *
   * @generated from field: optional bool jwt_groups_filter_infer_from_ppl = 175;
   */
  jwtGroupsFilterInferFromPpl?: boolean | undefined;

  /**
   * Cluster-wide default for how to interpret HTTP bearer tokens. Routes
   * may override per-route.
   *
   * @generated from field: optional pomerium.config.BearerTokenFormat bearer_token_format = 138;
   */
  bearerTokenFormat?: BearerTokenFormat | undefined;

  /**
   * Default per-request timeout applied to upstream HTTP requests when a
   * route does not specify its own.
   *
   * @generated from field: optional google.protobuf.Duration default_upstream_timeout = 39;
   */
  defaultUpstreamTimeout?: Duration | undefined;

  /**
   * Address (host:port) on which Pomerium exposes its pprof debug
   * endpoints. Empty disables them.
   *
   * @generated from field: optional string debug_address = 156;
   */
  debugAddress?: string | undefined;

  /**
   * Address (host:port) on which Pomerium serves Prometheus metrics.
   *
   * @generated from field: optional string metrics_address = 40;
   */
  metricsAddress?: string | undefined;

  /**
   * HTTP Basic Auth credentials required to access `metrics_address`, of
   * the form "user:password". Empty disables auth.
   *
   * @generated from field: optional string metrics_basic_auth = 64;
   */
  metricsBasicAuth?: string | undefined;

  /**
   * TLS certificate/key pair Pomerium uses on the metrics listener.
   *
   * @generated from field: optional pomerium.config.Settings.Certificate metrics_certificate = 65;
   */
  metricsCertificate?: Settings_Certificate | undefined;

  /**
   * PEM-encoded CA bundle used to authenticate clients connecting to the
   * metrics listener.
   *
   * @generated from field: optional string metrics_client_ca = 66;
   */
  metricsClientCa?: string | undefined;

  /**
   * ID of a managed key pair whose certificate is used as the metrics
   * client CA bundle, as an alternative to `metrics_client_ca`.
   *
   * @generated from field: optional string metrics_client_ca_key_pair_id = 164;
   */
  metricsClientCaKeyPairId?: string | undefined;

  /**
   * Which OpenTelemetry traces exporter to use ("otlp", "none", …). Empty
   * disables tracing.
   *
   * @generated from field: optional string otel_traces_exporter = 121;
   */
  otelTracesExporter?: string | undefined;

  /**
   * OpenTelemetry sampler argument. For ratio-based samplers this is the
   * sampling probability (0.0–1.0).
   *
   * @generated from field: optional double otel_traces_sampler_arg = 122;
   */
  otelTracesSamplerArg?: number | undefined;

  /**
   * OpenTelemetry resource attributes appended to every emitted span/log,
   * as "key=value" strings.
   *
   * @generated from field: repeated string otel_resource_attributes = 123;
   */
  otelResourceAttributes: string[];

  /**
   * Log level for the OpenTelemetry SDK itself.
   *
   * @generated from field: optional string otel_log_level = 124;
   */
  otelLogLevel?: string | undefined;

  /**
   * Maximum length of a single OpenTelemetry attribute value before it is
   * truncated.
   *
   * @generated from field: optional int32 otel_attribute_value_length_limit = 125;
   */
  otelAttributeValueLengthLimit?: number | undefined;

  /**
   * Default OTLP endpoint Pomerium dials for any OTLP exporter (traces,
   * logs) when no signal-specific endpoint is set.
   *
   * @generated from field: optional string otel_exporter_otlp_endpoint = 126;
   */
  otelExporterOtlpEndpoint?: string | undefined;

  /**
   * OTLP endpoint specifically for traces; overrides
   * `otel_exporter_otlp_endpoint` for the trace signal.
   *
   * @generated from field: optional string otel_exporter_otlp_traces_endpoint = 127;
   */
  otelExporterOtlpTracesEndpoint?: string | undefined;

  /**
   * OTLP transport protocol ("grpc" or "http/protobuf").
   *
   * @generated from field: optional string otel_exporter_otlp_protocol = 128;
   */
  otelExporterOtlpProtocol?: string | undefined;

  /**
   * OTLP transport protocol used specifically for traces.
   *
   * @generated from field: optional string otel_exporter_otlp_traces_protocol = 129;
   */
  otelExporterOtlpTracesProtocol?: string | undefined;

  /**
   * Headers attached to every OTLP request, as "key=value" strings (e.g.
   * for tenant identification).
   *
   * @generated from field: repeated string otel_exporter_otlp_headers = 130;
   */
  otelExporterOtlpHeaders: string[];

  /**
   * OTLP headers used specifically for traces.
   *
   * @generated from field: repeated string otel_exporter_otlp_traces_headers = 131;
   */
  otelExporterOtlpTracesHeaders: string[];

  /**
   * Per-request timeout for the OTLP exporter.
   *
   * @generated from field: optional google.protobuf.Duration otel_exporter_otlp_timeout = 132;
   */
  otelExporterOtlpTimeout?: Duration | undefined;

  /**
   * Per-request timeout used specifically for the OTLP traces exporter.
   *
   * @generated from field: optional google.protobuf.Duration otel_exporter_otlp_traces_timeout = 133;
   */
  otelExporterOtlpTracesTimeout?: Duration | undefined;

  /**
   * Delay between scheduled batches of spans the BatchSpanProcessor
   * exports.
   *
   * @generated from field: optional google.protobuf.Duration otel_bsp_schedule_delay = 134;
   */
  otelBspScheduleDelay?: Duration | undefined;

  /**
   * Maximum number of spans per export batch.
   *
   * @generated from field: optional int32 otel_bsp_max_export_batch_size = 135;
   */
  otelBspMaxExportBatchSize?: number | undefined;

  /**
   * Address (host:port) on which Pomerium serves its gRPC API.
   *
   * @generated from field: optional string grpc_address = 46;
   */
  grpcAddress?: string | undefined;

  /**
   * When true, Pomerium speaks plaintext gRPC instead of TLS. Intended for
   * co-located service deployments behind a trusted network boundary.
   *
   * @generated from field: optional bool grpc_insecure = 47;
   */
  grpcInsecure?: boolean | undefined;

  /**
   * Per-request timeout applied to gRPC client calls Pomerium makes to its
   * own services (authorize, databroker).
   *
   * @generated from field: optional google.protobuf.Duration grpc_client_timeout = 99;
   */
  grpcClientTimeout?: Duration | undefined;

  /**
   * Node ID of the databroker Raft leader, as observed by this process.
   *
   * @generated from field: optional string databroker_cluster_leader_id = 152;
   */
  databrokerClusterLeaderId?: string | undefined;

  /**
   * Node ID this process uses when participating in the databroker
   * cluster.
   *
   * @generated from field: optional string databroker_cluster_node_id = 150;
   */
  databrokerClusterNodeId?: string | undefined;

  /**
   * Full membership list of the databroker cluster.
   *
   * @generated from field: optional pomerium.config.Settings.DataBrokerClusterNodes databroker_cluster_nodes = 151;
   */
  databrokerClusterNodes?: Settings_DataBrokerClusterNodes | undefined;

  /**
   * Externally accessible URLs for the databroker service.
   *
   * @generated from field: repeated string databroker_service_urls = 52;
   */
  databrokerServiceUrls: string[];

  /**
   * URL Pomerium uses internally to reach the databroker service.
   *
   * @generated from field: optional string databroker_internal_service_url = 84;
   */
  databrokerInternalServiceUrl?: string | undefined;

  /**
   * Bind address (host:port) for this node's Raft transport.
   *
   * @generated from field: optional string databroker_raft_bind_address = 155;
   */
  databrokerRaftBindAddress?: string | undefined;

  /**
   * Backing-store type for the databroker ("memory", "postgres", …).
   *
   * @generated from field: optional string databroker_storage_type = 101;
   */
  databrokerStorageType?: string | undefined;

  /**
   * Connection string for the databroker storage backend, when applicable.
   *
   * @generated from field: optional string databroker_storage_connection_string = 102;
   */
  databrokerStorageConnectionString?: string | undefined;

  /**
   * Downstream (end-user) mTLS validation configuration.
   *
   * @generated from field: optional pomerium.config.DownstreamMtlsSettings downstream_mtls = 116;
   */
  downstreamMtls?: DownstreamMtlsSettings | undefined;

  /**
   * Google Cloud service account email Pomerium uses to obtain ID tokens
   * for Cloud Run / serverless upstream targets.
   *
   * @generated from field: optional string google_cloud_serverless_authentication_service_account = 55;
   */
  googleCloudServerlessAuthenticationServiceAccount?: string | undefined;

  /**
   * When true, Pomerium expects downstream connections to begin with the
   * HAProxy PROXY protocol header (v1 or v2).
   *
   * @generated from field: optional bool use_proxy_protocol = 107;
   */
  useProxyProtocol?: boolean | undefined;

  /**
   * When true, Pomerium uses ACME to automatically obtain and renew TLS
   * certificates for the configured route hostnames.
   *
   * @generated from field: optional bool autocert = 56;
   */
  autocert?: boolean | undefined;

  /**
   * Directory URL of the ACME CA to use when `autocert` is enabled.
   *
   * @generated from field: optional string autocert_ca = 76;
   */
  autocertCa?: string | undefined;

  /**
   * ID of a managed key pair whose certificate Pomerium presents to the
   * ACME CA for account binding.
   *
   * @generated from field: optional string autocert_ca_key_pair_id = 165;
   */
  autocertCaKeyPairId?: string | undefined;

  /**
   * Email address Pomerium registers with the ACME CA. Required by most
   * CAs for expiration notifications.
   *
   * @generated from field: optional string autocert_email = 77;
   */
  autocertEmail?: string | undefined;

  /**
   * When true, Pomerium uses Let's Encrypt's staging environment. Useful
   * for testing to avoid hitting rate limits.
   *
   * @generated from field: optional bool autocert_use_staging = 57;
   */
  autocertUseStaging?: boolean | undefined;

  /**
   * External Account Binding key identifier provided by the ACME CA.
   *
   * @generated from field: optional string autocert_eab_key_id = 78;
   */
  autocertEabKeyId?: string | undefined;

  /**
   * Base64-URL-encoded EAB MAC key paired with `autocert_eab_key_id`.
   *
   * @generated from field: optional string autocert_eab_mac_key = 79;
   */
  autocertEabMacKey?: string | undefined;

  /**
   * When true, Pomerium requests certificates with the OCSP Must-Staple
   * extension.
   *
   * @generated from field: optional bool autocert_must_staple = 58;
   */
  autocertMustStaple?: boolean | undefined;

  /**
   * Filesystem directory Pomerium uses to cache obtained certificates and
   * ACME account state.
   *
   * @generated from field: optional string autocert_dir = 59;
   */
  autocertDir?: string | undefined;

  /**
   * PEM-encoded CA bundle Pomerium trusts when validating the ACME CA's
   * own TLS certificate, for private ACME servers.
   *
   * @generated from field: optional string autocert_trusted_ca = 80;
   */
  autocertTrustedCa?: string | undefined;

  /**
   * ID of a managed key pair whose certificate is used as the trusted CA
   * for the ACME server, as an alternative to `autocert_trusted_ca`.
   *
   * @generated from field: optional string autocert_trusted_ca_key_pair_id = 166;
   */
  autocertTrustedCaKeyPairId?: string | undefined;

  /**
   * When true, Pomerium does not append the immediate client IP to the
   * X-Forwarded-For header on upstream requests.
   *
   * @generated from field: optional bool skip_xff_append = 61;
   */
  skipXffAppend?: boolean | undefined;

  /**
   * Number of trusted hops Pomerium considers when extracting the
   * client IP from the X-Forwarded-For header.
   *
   * @generated from field: optional uint32 xff_num_trusted_hops = 70;
   */
  xffNumTrustedHops?: number | undefined;

  /**
   * Path to which Envoy writes admin-interface access logs. Empty
   * disables admin-access logging.
   *
   * @generated from field: optional string envoy_admin_access_log_path = 108;
   */
  envoyAdminAccessLogPath?: string | undefined;

  /**
   * Path to which Envoy writes pprof profiles when requested via the
   * admin interface.
   *
   * @generated from field: optional string envoy_admin_profile_path = 109;
   */
  envoyAdminProfilePath?: string | undefined;

  /**
   * Address (host:port) on which Envoy exposes its admin interface.
   * Empty disables the admin interface.
   *
   * @generated from field: optional string envoy_admin_address = 110;
   */
  envoyAdminAddress?: string | undefined;

  /**
   * Source address Envoy binds when connecting to upstreams.
   *
   * @generated from field: optional string envoy_bind_config_source_address = 111;
   */
  envoyBindConfigSourceAddress?: string | undefined;

  /**
   * When true, Envoy's upstream connections set IP_FREEBIND, allowing
   * binding to non-local addresses.
   *
   * @generated from field: optional bool envoy_bind_config_freebind = 112;
   */
  envoyBindConfigFreebind?: boolean | undefined;

  /**
   * Hostnames Pomerium allows in programmatic-login redirect URLs.
   *
   * @generated from field: repeated string programmatic_redirect_domain_whitelist = 68;
   */
  programmaticRedirectDomainWhitelist: string[];

  /**
   * Default HTTP codec used for downstream connections.
   *
   * @generated from field: optional pomerium.config.CodecType codec_type = 73;
   */
  codecType?: CodecType | undefined;

  /**
   * Primary brand color (hex string like "#1e88e5") used in the
   * Pomerium-served sign-in and error pages.
   *
   * @generated from field: optional string primary_color = 85;
   */
  primaryColor?: string | undefined;

  /**
   * Secondary brand color (hex string).
   *
   * @generated from field: optional string secondary_color = 86;
   */
  secondaryColor?: string | undefined;

  /**
   * Primary brand color used in dark mode.
   *
   * @generated from field: optional string darkmode_primary_color = 87;
   */
  darkmodePrimaryColor?: string | undefined;

  /**
   * Secondary brand color used in dark mode.
   *
   * @generated from field: optional string darkmode_secondary_color = 88;
   */
  darkmodeSecondaryColor?: string | undefined;

  /**
   * URL of the logo image displayed on Pomerium-served pages.
   *
   * @generated from field: optional string logo_url = 89;
   */
  logoUrl?: string | undefined;

  /**
   * URL of the favicon used on Pomerium-served pages.
   *
   * @generated from field: optional string favicon_url = 90;
   */
  faviconUrl?: string | undefined;

  /**
   * First paragraph of the error message Pomerium shows on access denied
   * pages, before the auto-generated diagnostic text.
   *
   * @generated from field: optional string error_message_first_paragraph = 91;
   */
  errorMessageFirstParagraph?: string | undefined;

  /**
   * When true, Pomerium adds X-Pomerium-* identity headers to upstream
   * requests in addition to the signed JWT.
   *
   * @generated from field: optional bool pass_identity_headers = 117;
   */
  passIdentityHeaders?: boolean | undefined;

  /**
   * Per-flag boolean overrides for Pomerium runtime feature gates. The
   * set of supported keys evolves with the release.
   *
   * @generated from field: map<string, bool> runtime_flags = 118;
   */
  runtimeFlags: { [key: string]: boolean };

  /**
   * Port advertised in the Alt-Svc header so clients can upgrade to HTTP/3
   * (QUIC). Zero disables advertisement.
   *
   * @generated from field: optional uint32 http3_advertise_port = 136;
   */
  http3AdvertisePort?: number | undefined;

  /**
   * Default upstream circuit-breaker thresholds applied to all routes
   * unless overridden per route.
   *
   * @generated from field: optional pomerium.config.CircuitBreakerThresholds circuit_breaker_thresholds = 140;
   */
  circuitBreakerThresholds?: CircuitBreakerThresholds | undefined;

  /**
   * Address (host:port) on which Pomerium listens for SSH traffic.
   * Empty disables the SSH proxy.
   *
   * @generated from field: optional string ssh_address = 141;
   */
  sshAddress?: string | undefined;

  /**
   * Paths to host-key files Pomerium reads at startup to authenticate
   * itself to SSH clients.
   *
   * @generated from field: optional pomerium.config.Settings.StringList ssh_host_key_files = 142;
   */
  sshHostKeyFiles?: Settings_StringList | undefined;

  /**
   * Inline SSH host keys, used in place of `ssh_host_key_files`.
   *
   * @generated from field: optional pomerium.config.Settings.StringList ssh_host_keys = 143;
   */
  sshHostKeys?: Settings_StringList | undefined;

  /**
   * IDs of managed key pairs to use as SSH host keys, as an alternative
   * to file or inline values.
   *
   * @generated from field: repeated string ssh_host_key_pair_ids = 167;
   */
  sshHostKeyPairIds: string[];

  /**
   * Path to a file containing the SSH user-CA private key Pomerium uses
   * to issue short-lived SSH user certificates.
   *
   * @generated from field: optional string ssh_user_ca_key_file = 144;
   */
  sshUserCaKeyFile?: string | undefined;

  /**
   * Inline SSH user-CA private key, used in place of
   * `ssh_user_ca_key_file`.
   *
   * @generated from field: optional string ssh_user_ca_key = 145;
   */
  sshUserCaKey?: string | undefined;

  /**
   * ID of a managed key pair to use as the SSH user-CA key, as an
   * alternative to file or inline values.
   *
   * @generated from field: optional string ssh_user_ca_key_pair_id = 168;
   */
  sshUserCaKeyPairId?: string | undefined;

  /**
   * mcp_allowed_client_id_domains specifies the allowed domains for MCP client ID metadata URLs.
   * Supports wildcard patterns like "*.example.com".
   * This is REQUIRED when MCP is enabled - client metadata fetching will fail if empty.
   *
   * @generated from field: repeated string mcp_allowed_client_id_domains = 157;
   */
  mcpAllowedClientIdDomains: string[];

  /**
   * mcp_allowed_as_metadata_domains specifies the allowed domains for upstream AS/PRM metadata URLs.
   * Supports wildcard patterns like "*.example.com".
   * This restricts which domains Pomerium will contact during upstream OAuth discovery.
   *
   * @generated from field: repeated string mcp_allowed_as_metadata_domains = 177;
   */
  mcpAllowedAsMetadataDomains: string[];

  /**
   * Directory-sync provider Pomerium uses to enumerate users and groups
   * ("auth0", "okta", "azure", …). Empty disables directory sync.
   *
   * @generated from field: optional string directory_provider = 171;
   */
  directoryProvider?: string | undefined;

  /**
   * Provider-specific options for the directory provider, as a generic
   * JSON object.
   *
   * @generated from field: optional google.protobuf.Struct directory_provider_options = 172;
   */
  directoryProviderOptions?: JsonObject | undefined;

  /**
   * How often Pomerium refreshes the directory cache.
   *
   * @generated from field: optional google.protobuf.Duration directory_provider_refresh_interval = 173;
   */
  directoryProviderRefreshInterval?: Duration | undefined;

  /**
   * Per-attempt timeout for a single directory refresh cycle.
   *
   * @generated from field: optional google.protobuf.Duration directory_provider_refresh_timeout = 174;
   */
  directoryProviderRefreshTimeout?: Duration | undefined;

  /**
   * Object-storage backend Pomerium uses for large artifacts (session
   * recordings, exports). Empty disables blob storage.
   *
   * @generated from field: optional pomerium.config.BlobStorageSettings blob_storage = 179;
   */
  blobStorage?: BlobStorageSettings | undefined;

  /**
   * auto_apply_changesets controls whether or not changesets are automatically
   * applied or require an adminstrator to apply them. This setting is
   * currently only used in Pomerium Zero.
   *
   * @generated from field: optional bool auto_apply_changesets = 180;
   */
  autoApplyChangesets?: boolean | undefined;

  /**
   * Allows HTTP upgrade requests to be forwarded upstream.
   *
   * @generated from field: optional pomerium.config.Settings.StringList allow_upgrades = 181;
   */
  allowUpgrades?: Settings_StringList | undefined;

  /**
   * File paths to the extensions to be loaded by envoy at runtime.
   *
   * @generated from field: pomerium.config.Settings.StringList envoy_dynamic_extensions = 182;
   */
  envoyDynamicExtensions?: Settings_StringList | undefined;

  /**
   * Tunes the maximum number of worker threads that envoy allocates for session recording
   * uploading
   *
   * @generated from field: optional uint32 session_recording_concurrency = 183;
   */
  sessionRecordingConcurrency?: number | undefined;

  /**
   * Should paths be normalized according to RFC 3986 before any processing of
   * requests by HTTP filters or routing? Defaults to true.
   *
   * @generated from field: optional bool normalize_path = 184;
   */
  normalizePath?: boolean | undefined;

  /**
   * Determines if adjacent slashes in the path are merged into one before any
   * processing of requests by HTTP filters or routing. Defaults to true.
   *
   * @generated from field: optional bool merge_slashes = 185;
   */
  mergeSlashes?: boolean | undefined;

  /**
   * Action to take when request URL path contains escaped slash sequences
   * (%2F, %2f, %5C and %5c). Defaults to rejecting requests.
   *
   * @generated from field: optional pomerium.config.PathWithEscapedSlashesAction path_with_escaped_slashes_action = 186;
   */
  pathWithEscapedSlashesAction?: PathWithEscapedSlashesAction | undefined;

  /**
   * Action to take when a client request with a header name containing
   * underscore characters is received. Defaults to rejecting the request.
   *
   * @generated from field: optional pomerium.config.HeadersWithUnderscoresAction headers_with_underscores_action = 187;
   */
  headersWithUnderscoresAction?: HeadersWithUnderscoresAction | undefined;

  /**
   * When the settings were created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 169;
   */
  createdAt?: Timestamp | undefined;

  /**
   * When the settings were last modified.
   *
   * @generated from field: google.protobuf.Timestamp modified_at = 170;
   */
  modifiedAt?: Timestamp | undefined;
};

/**
 * Describes the message pomerium.config.Settings.
 * Use `create(SettingsSchema)` to create a new message.
 */
export const SettingsSchema: GenMessage<Settings> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 17);

/**
 * An inline TLS certificate/key pair Pomerium serves for matching SNI
 * hostnames.
 *
 * @generated from message pomerium.config.Settings.Certificate
 */
export type Settings_Certificate = Message<"pomerium.config.Settings.Certificate"> & {
  /**
   * PEM-encoded certificate chain.
   *
   * @generated from field: bytes cert_bytes = 3;
   */
  certBytes: Uint8Array;

  /**
   * PEM-encoded private key matching `cert_bytes`.
   *
   * @generated from field: bytes key_bytes = 4;
   */
  keyBytes: Uint8Array;

  /**
   * Optional identifier for the certificate, used to refer to it from
   * other parts of the configuration.
   *
   * @generated from field: string id = 5;
   */
  id: string;
};

/**
 * Describes the message pomerium.config.Settings.Certificate.
 * Use `create(Settings_CertificateSchema)` to create a new message.
 */
export const Settings_CertificateSchema: GenMessage<Settings_Certificate> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 17, 0);

/**
 * One peer in a Pomerium databroker Raft cluster.
 *
 * @generated from message pomerium.config.Settings.DataBrokerClusterNode
 */
export type Settings_DataBrokerClusterNode = Message<"pomerium.config.Settings.DataBrokerClusterNode"> & {
  /**
   * Stable identifier of the node within the cluster.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * gRPC service address (host:port) other components dial to reach this
   * databroker node.
   *
   * @generated from field: string grpc_address = 2;
   */
  grpcAddress: string;

  /**
   * Raft transport address (host:port) used for peer-to-peer replication.
   *
   * @generated from field: optional string raft_address = 3;
   */
  raftAddress?: string | undefined;
};

/**
 * Describes the message pomerium.config.Settings.DataBrokerClusterNode.
 * Use `create(Settings_DataBrokerClusterNodeSchema)` to create a new message.
 */
export const Settings_DataBrokerClusterNodeSchema: GenMessage<Settings_DataBrokerClusterNode> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 17, 1);

/**
 * Aggregate list of databroker cluster peers.
 *
 * @generated from message pomerium.config.Settings.DataBrokerClusterNodes
 */
export type Settings_DataBrokerClusterNodes = Message<"pomerium.config.Settings.DataBrokerClusterNodes"> & {
  /**
   * Every node participating in the databroker cluster.
   *
   * @generated from field: repeated pomerium.config.Settings.DataBrokerClusterNode nodes = 1;
   */
  nodes: Settings_DataBrokerClusterNode[];
};

/**
 * Describes the message pomerium.config.Settings.DataBrokerClusterNodes.
 * Use `create(Settings_DataBrokerClusterNodesSchema)` to create a new message.
 */
export const Settings_DataBrokerClusterNodesSchema: GenMessage<Settings_DataBrokerClusterNodes> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 17, 2);

/**
 * Wrapper for a list of strings, used so map-valued Settings fields can
 * hold repeated string values.
 *
 * @generated from message pomerium.config.Settings.StringList
 */
export type Settings_StringList = Message<"pomerium.config.Settings.StringList"> & {
  /**
   * The string values held by this list.
   *
   * @generated from field: repeated string values = 1;
   */
  values: string[];
};

/**
 * Describes the message pomerium.config.Settings.StringList.
 * Use `create(Settings_StringListSchema)` to create a new message.
 */
export const Settings_StringListSchema: GenMessage<Settings_StringList> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 17, 3);

/**
 * BlobStorageSettings configures the object-storage backend Pomerium uses
 * for large artifacts such as session recordings.
 *
 * @generated from message pomerium.config.BlobStorageSettings
 */
export type BlobStorageSettings = Message<"pomerium.config.BlobStorageSettings"> & {
  /**
   * URI of the object-storage bucket (e.g. "s3://my-bucket",
   * "gs://my-bucket"). Empty disables blob storage.
   *
   * @generated from field: optional string bucket_uri = 1;
   */
  bucketUri?: string | undefined;

  /**
   * Prefix assigned by a connected Pomerium Enterprise instance. End users
   * should not set or modify this field unless they know exactly what they
   * are doing or are working around a specific issue.
   *
   * @generated from field: optional string managed_prefix = 2;
   */
  managedPrefix?: string | undefined;
};

/**
 * Describes the message pomerium.config.BlobStorageSettings.
 * Use `create(BlobStorageSettingsSchema)` to create a new message.
 */
export const BlobStorageSettingsSchema: GenMessage<BlobStorageSettings> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 18);

/**
 * DownstreamMtlsSettings controls how Pomerium validates client certificates
 * presented by downstream (end-user) connections.
 *
 * @generated from message pomerium.config.DownstreamMtlsSettings
 */
export type DownstreamMtlsSettings = Message<"pomerium.config.DownstreamMtlsSettings"> & {
  /**
   * PEM-encoded certificate authority bundle used to verify client
   * certificates.
   *
   * @generated from field: optional string ca = 1;
   */
  ca?: string | undefined;

  /**
   * PEM-encoded certificate revocation list checked against client
   * certificates.
   *
   * @generated from field: optional string crl = 2;
   */
  crl?: string | undefined;

  /**
   * How aggressively client certificate requirements are enforced.
   *
   * @generated from field: optional pomerium.config.MtlsEnforcementMode enforcement = 3;
   */
  enforcement?: MtlsEnforcementMode | undefined;

  /**
   * Patterns the certificate Subject Alternative Names must satisfy for the
   * connection to be allowed.
   *
   * @generated from field: repeated pomerium.config.SANMatcher match_subject_alt_names = 4;
   */
  matchSubjectAltNames: SANMatcher[];

  /**
   * Maximum depth of the verification chain accepted from clients. Zero
   * means use Envoy's default.
   *
   * @generated from field: optional uint32 max_verify_depth = 5;
   */
  maxVerifyDepth?: number | undefined;

  /**
   * ID of a managed key pair whose certificate is used as the client CA,
   * as an alternative to the inline `ca` value.
   *
   * @generated from field: optional string ca_key_pair_id = 6;
   */
  caKeyPairId?: string | undefined;
};

/**
 * Describes the message pomerium.config.DownstreamMtlsSettings.
 * Use `create(DownstreamMtlsSettingsSchema)` to create a new message.
 */
export const DownstreamMtlsSettingsSchema: GenMessage<DownstreamMtlsSettings> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 19);

/**
 * SANMatcher describes a constraint against one Subject Alternative Name
 * entry in a client certificate.
 *
 * @generated from message pomerium.config.SANMatcher
 */
export type SANMatcher = Message<"pomerium.config.SANMatcher"> & {
  /**
   * Which SAN entry type this pattern applies to.
   *
   * @generated from field: pomerium.config.SANMatcher.SANType san_type = 1;
   */
  sanType: SANMatcher_SANType;

  /**
   * Regular expression the SAN value must fully match.
   *
   * @generated from field: string pattern = 2;
   */
  pattern: string;
};

/**
 * Describes the message pomerium.config.SANMatcher.
 * Use `create(SANMatcherSchema)` to create a new message.
 */
export const SANMatcherSchema: GenMessage<SANMatcher> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 20);

/**
 * Represents a certificate Subject Alternative Name type.
 *
 * @generated from enum pomerium.config.SANMatcher.SANType
 */
export enum SANMatcher_SANType {
  /**
   * @generated from enum value: SAN_TYPE_UNSPECIFIED = 0;
   */
  SAN_TYPE_UNSPECIFIED = 0,

  /**
   * Represents an email address.
   *
   * @generated from enum value: EMAIL = 1;
   */
  EMAIL = 1,

  /**
   * Represents a DNS name.
   *
   * @generated from enum value: DNS = 2;
   */
  DNS = 2,

  /**
   * Represents a URI.
   *
   * @generated from enum value: URI = 3;
   */
  URI = 3,

  /**
   * Represents an IP address.
   *
   * @generated from enum value: IP_ADDRESS = 4;
   */
  IP_ADDRESS = 4,

  /**
   * Represents a UserPrincipalName (otherName with type ID
   * 1.3.6.1.4.1.311.20.2.3).
   *
   * @generated from enum value: USER_PRINCIPAL_NAME = 5;
   */
  USER_PRINCIPAL_NAME = 5,
}

/**
 * Describes the enum pomerium.config.SANMatcher.SANType.
 */
export const SANMatcher_SANTypeSchema: GenEnum<SANMatcher_SANType> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 20, 0);

/**
 * A KeyPair represents a public / private key pair.
 *
 * @generated from message pomerium.config.KeyPair
 */
export type KeyPair = Message<"pomerium.config.KeyPair"> & {
  /**
   * ID of the key pair.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * Namespace of the key pair.
   *
   * @generated from field: optional string namespace_id = 2;
   */
  namespaceId?: string | undefined;

  /**
   * Originator of the key pair.
   *
   * @generated from field: optional string originator_id = 3;
   */
  originatorId?: string | undefined;

  /**
   * The name of the key pair.
   *
   * @generated from field: optional string name = 4;
   */
  name?: string | undefined;

  /**
   * The key pair certificate raw bytes.
   *
   * @generated from field: optional bytes certificate = 5;
   */
  certificate?: Uint8Array | undefined;

  /**
   * The key pair private key raw bytes.
   *
   * @generated from field: optional bytes key = 6;
   */
  key?: Uint8Array | undefined;

  /**
   * When the key pair was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * When the key pair was last modified.
   *
   * @generated from field: google.protobuf.Timestamp modified_at = 8;
   */
  modifiedAt?: Timestamp | undefined;

  /**
   * The status of the key pair.
   *
   * @generated from field: pomerium.config.KeyPairStatus status = 9;
   */
  status: KeyPairStatus;

  /**
   * The origin of the key pair.
   *
   * @generated from field: pomerium.config.KeyPairOrigin origin = 10;
   */
  origin: KeyPairOrigin;

  /**
   * Info about any certificates the key pair has.
   *
   * @generated from field: repeated pomerium.config.CertificateInfo certificate_info = 11;
   */
  certificateInfo: CertificateInfo[];
};

/**
 * Describes the message pomerium.config.KeyPair.
 * Use `create(KeyPairSchema)` to create a new message.
 */
export const KeyPairSchema: GenMessage<KeyPair> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 21);

/**
 * KeyUsage specifies the usage flags set on a signed TLS certificate.
 * Each field maps to one bit of the X.509 KeyUsage / ExtKeyUsage extensions.
 *
 * @generated from message pomerium.config.KeyUsage
 */
export type KeyUsage = Message<"pomerium.config.KeyUsage"> & {
  /**
   * Certificate authorizes verifying digital signatures.
   *
   * @generated from field: bool digital_signature = 1;
   */
  digitalSignature: boolean;

  /**
   * Certificate authorizes non-repudiation of signed data.
   *
   * @generated from field: bool content_commitment = 2;
   */
  contentCommitment: boolean;

  /**
   * Certificate authorizes key transport (encryption of session keys).
   *
   * @generated from field: bool key_encipherment = 3;
   */
  keyEncipherment: boolean;

  /**
   * Certificate authorizes direct encryption of arbitrary data.
   *
   * @generated from field: bool data_encipherment = 4;
   */
  dataEncipherment: boolean;

  /**
   * Certificate authorizes Diffie-Hellman style key agreement.
   *
   * @generated from field: bool key_agreement = 5;
   */
  keyAgreement: boolean;

  /**
   * Certificate authorizes signing other certificates (CA).
   *
   * @generated from field: bool cert_sign = 6;
   */
  certSign: boolean;

  /**
   * Certificate authorizes signing certificate revocation lists.
   *
   * @generated from field: bool crl_sign = 7;
   */
  crlSign: boolean;

  /**
   * With key_agreement, restricts use to encipherment only.
   *
   * @generated from field: bool encipher_only = 8;
   */
  encipherOnly: boolean;

  /**
   * With key_agreement, restricts use to decipherment only.
   *
   * @generated from field: bool decipher_only = 9;
   */
  decipherOnly: boolean;

  /**
   * Extended usage: server authentication (TLS server certificates).
   *
   * @generated from field: bool server_auth = 10;
   */
  serverAuth: boolean;

  /**
   * Extended usage: client authentication (TLS client certificates).
   *
   * @generated from field: bool client_auth = 11;
   */
  clientAuth: boolean;
};

/**
 * Describes the message pomerium.config.KeyUsage.
 * Use `create(KeyUsageSchema)` to create a new message.
 */
export const KeyUsageSchema: GenMessage<KeyUsage> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 22);

/**
 * Name defines an X.509 distinguished name (RFC 5280 §4.1.2.4). Multi-valued
 * attributes are returned in DER order.
 *
 * @generated from message pomerium.config.Name
 */
export type Name = Message<"pomerium.config.Name"> & {
  /**
   * Two-letter ISO country codes from the C= relative distinguished name.
   *
   * @generated from field: repeated string country = 1;
   */
  country: string[];

  /**
   * Organization (O=) entries.
   *
   * @generated from field: repeated string organization = 2;
   */
  organization: string[];

  /**
   * Organizational unit (OU=) entries.
   *
   * @generated from field: repeated string organizational_unit = 3;
   */
  organizationalUnit: string[];

  /**
   * Locality (L=) entries — typically a city.
   *
   * @generated from field: repeated string locality = 4;
   */
  locality: string[];

  /**
   * State or province (ST=) entries.
   *
   * @generated from field: repeated string province = 5;
   */
  province: string[];

  /**
   * Street address (STREET=) entries.
   *
   * @generated from field: repeated string street_address = 6;
   */
  streetAddress: string[];

  /**
   * Postal code (postalCode=) entries.
   *
   * @generated from field: repeated string postal_code = 7;
   */
  postalCode: string[];

  /**
   * X.509 serialNumber attribute of the name (not the certificate serial).
   *
   * @generated from field: string serial_number = 8;
   */
  serialNumber: string;

  /**
   * Common name (CN=).
   *
   * @generated from field: string common_name = 9;
   */
  commonName: string;
};

/**
 * Describes the message pomerium.config.Name.
 * Use `create(NameSchema)` to create a new message.
 */
export const NameSchema: GenMessage<Name> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 23);

/**
 * CertificateInfo is a .proto reflection of
 * https://golang.org/pkg/crypto/x509/#Certificate
 *
 * @generated from message pomerium.config.CertificateInfo
 */
export type CertificateInfo = Message<"pomerium.config.CertificateInfo"> & {
  /**
   * X.509 certificate format version (3 for modern certificates).
   *
   * @generated from field: int64 version = 1;
   */
  version: bigint;

  /**
   * Certificate serial number, formatted as a decimal integer string.
   *
   * @generated from field: string serial = 2;
   */
  serial: string;

  /**
   * Issuer distinguished name (the CA that signed this certificate).
   *
   * @generated from field: pomerium.config.Name issuer = 3;
   */
  issuer?: Name | undefined;

  /**
   * Subject distinguished name (the identity the certificate vouches for).
   *
   * @generated from field: pomerium.config.Name subject = 4;
   */
  subject?: Name | undefined;

  /**
   * First instant the certificate is valid.
   *
   * @generated from field: google.protobuf.Timestamp not_before = 5;
   */
  notBefore?: Timestamp | undefined;

  /**
   * First instant the certificate is no longer valid.
   *
   * @generated from field: google.protobuf.Timestamp not_after = 6;
   */
  notAfter?: Timestamp | undefined;

  /**
   * Decoded KeyUsage and ExtKeyUsage extensions on the certificate.
   *
   * @generated from field: pomerium.config.KeyUsage key_usage = 7;
   */
  keyUsage?: KeyUsage | undefined;

  /**
   * DNS names in the Subject Alternative Name extension.
   *
   * @generated from field: repeated string dns_names = 10;
   */
  dnsNames: string[];

  /**
   * Email addresses in the Subject Alternative Name extension.
   *
   * @generated from field: repeated string email_addresses = 11;
   */
  emailAddresses: string[];

  /**
   * IP addresses in the Subject Alternative Name extension, formatted as
   * strings (IPv4 dotted-decimal or IPv6 colon-hex).
   *
   * @generated from field: repeated string ip_addresses = 12;
   */
  ipAddresses: string[];

  /**
   * URIs in the Subject Alternative Name extension.
   *
   * @generated from field: repeated string uris = 13;
   */
  uris: string[];

  /**
   * When true the permitted/excluded DNS-domain name-constraints are marked
   * critical and clients must understand them or reject the certificate.
   *
   * @generated from field: bool permitted_dns_domains_critical = 14;
   */
  permittedDnsDomainsCritical: boolean;

  /**
   * Name constraints: DNS domains the certificate is permitted to assert.
   *
   * @generated from field: repeated string permitted_dns_domains = 15;
   */
  permittedDnsDomains: string[];

  /**
   * Name constraints: DNS domains the certificate must not assert.
   *
   * @generated from field: repeated string excluded_dns_domains = 16;
   */
  excludedDnsDomains: string[];

  /**
   * Name constraints: IP-range CIDRs the certificate is permitted to assert.
   *
   * @generated from field: repeated string permitted_ip_ranges = 17;
   */
  permittedIpRanges: string[];

  /**
   * Name constraints: IP-range CIDRs the certificate must not assert.
   *
   * @generated from field: repeated string excluded_ip_ranges = 18;
   */
  excludedIpRanges: string[];

  /**
   * Name constraints: email addresses (or domains) the certificate is
   * permitted to assert.
   *
   * @generated from field: repeated string permitted_email_addresses = 19;
   */
  permittedEmailAddresses: string[];

  /**
   * Name constraints: email addresses (or domains) the certificate must not
   * assert.
   *
   * @generated from field: repeated string excluded_email_addresses = 20;
   */
  excludedEmailAddresses: string[];

  /**
   * Name constraints: URI domains the certificate is permitted to assert.
   *
   * @generated from field: repeated string permitted_uri_domains = 21;
   */
  permittedUriDomains: string[];

  /**
   * Name constraints: URI domains the certificate must not assert.
   *
   * @generated from field: repeated string excluded_uri_domains = 22;
   */
  excludedUriDomains: string[];
};

/**
 * Describes the message pomerium.config.CertificateInfo.
 * Use `create(CertificateInfoSchema)` to create a new message.
 */
export const CertificateInfoSchema: GenMessage<CertificateInfo> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 24);

/**
 * A ServiceAccount represents a Pomerium service account.
 *
 * @generated from message pomerium.config.ServiceAccount
 */
export type ServiceAccount = Message<"pomerium.config.ServiceAccount"> & {
  /**
   * ID of the service account.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * Namespace of the service account.
   *
   * @generated from field: optional string namespace_id = 2;
   */
  namespaceId?: string | undefined;

  /**
   * Originator of the service account.
   *
   * @generated from field: optional string originator_id = 3;
   */
  originatorId?: string | undefined;

  /**
   * Description of the service account.
   *
   * @generated from field: optional string description = 4;
   */
  description?: string | undefined;

  /**
   * User ID of the service account.
   *
   * @generated from field: optional string user_id = 5;
   */
  userId?: string | undefined;

  /**
   * When the service account expires.
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * When the service account was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * When the service account was last modified.
   *
   * @generated from field: google.protobuf.Timestamp modified_at = 8;
   */
  modifiedAt?: Timestamp | undefined;

  /**
   * When the service account was last accessed.
   *
   * @generated from field: google.protobuf.Timestamp accessed_at = 9;
   */
  accessedAt?: Timestamp | undefined;
};

/**
 * Describes the message pomerium.config.ServiceAccount.
 * Use `create(ServiceAccountSchema)` to create a new message.
 */
export const ServiceAccountSchema: GenMessage<ServiceAccount> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 25);

/**
 * @generated from message pomerium.config.CreateKeyPairRequest
 */
export type CreateKeyPairRequest = Message<"pomerium.config.CreateKeyPairRequest"> & {
  /**
   * The key pair to create.
   *
   * @generated from field: pomerium.config.KeyPair key_pair = 1;
   */
  keyPair?: KeyPair | undefined;
};

/**
 * Describes the message pomerium.config.CreateKeyPairRequest.
 * Use `create(CreateKeyPairRequestSchema)` to create a new message.
 */
export const CreateKeyPairRequestSchema: GenMessage<CreateKeyPairRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 26);

/**
 * @generated from message pomerium.config.CreateKeyPairResponse
 */
export type CreateKeyPairResponse = Message<"pomerium.config.CreateKeyPairResponse"> & {
  /**
   * The newly created key pair, including any server-assigned fields.
   *
   * @generated from field: pomerium.config.KeyPair key_pair = 1;
   */
  keyPair?: KeyPair | undefined;
};

/**
 * Describes the message pomerium.config.CreateKeyPairResponse.
 * Use `create(CreateKeyPairResponseSchema)` to create a new message.
 */
export const CreateKeyPairResponseSchema: GenMessage<CreateKeyPairResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 27);

/**
 * @generated from message pomerium.config.CreatePolicyRequest
 */
export type CreatePolicyRequest = Message<"pomerium.config.CreatePolicyRequest"> & {
  /**
   * The policy to create.
   *
   * @generated from field: pomerium.config.Policy policy = 1;
   */
  policy?: Policy | undefined;
};

/**
 * Describes the message pomerium.config.CreatePolicyRequest.
 * Use `create(CreatePolicyRequestSchema)` to create a new message.
 */
export const CreatePolicyRequestSchema: GenMessage<CreatePolicyRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 28);

/**
 * @generated from message pomerium.config.CreatePolicyResponse
 */
export type CreatePolicyResponse = Message<"pomerium.config.CreatePolicyResponse"> & {
  /**
   * The newly created policy, including any server-assigned fields.
   *
   * @generated from field: pomerium.config.Policy policy = 1;
   */
  policy?: Policy | undefined;
};

/**
 * Describes the message pomerium.config.CreatePolicyResponse.
 * Use `create(CreatePolicyResponseSchema)` to create a new message.
 */
export const CreatePolicyResponseSchema: GenMessage<CreatePolicyResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 29);

/**
 * @generated from message pomerium.config.CreateRouteRequest
 */
export type CreateRouteRequest = Message<"pomerium.config.CreateRouteRequest"> & {
  /**
   * The route to create.
   *
   * @generated from field: pomerium.config.Route route = 1;
   */
  route?: Route | undefined;
};

/**
 * Describes the message pomerium.config.CreateRouteRequest.
 * Use `create(CreateRouteRequestSchema)` to create a new message.
 */
export const CreateRouteRequestSchema: GenMessage<CreateRouteRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 30);

/**
 * @generated from message pomerium.config.CreateRouteResponse
 */
export type CreateRouteResponse = Message<"pomerium.config.CreateRouteResponse"> & {
  /**
   * The newly created route, including any server-assigned fields.
   *
   * @generated from field: pomerium.config.Route route = 1;
   */
  route?: Route | undefined;
};

/**
 * Describes the message pomerium.config.CreateRouteResponse.
 * Use `create(CreateRouteResponseSchema)` to create a new message.
 */
export const CreateRouteResponseSchema: GenMessage<CreateRouteResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 31);

/**
 * @generated from message pomerium.config.CreateServiceAccountRequest
 */
export type CreateServiceAccountRequest = Message<"pomerium.config.CreateServiceAccountRequest"> & {
  /**
   * The service account to create.
   *
   * @generated from field: pomerium.config.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount | undefined;
};

/**
 * Describes the message pomerium.config.CreateServiceAccountRequest.
 * Use `create(CreateServiceAccountRequestSchema)` to create a new message.
 */
export const CreateServiceAccountRequestSchema: GenMessage<CreateServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 32);

/**
 * @generated from message pomerium.config.CreateServiceAccountResponse
 */
export type CreateServiceAccountResponse = Message<"pomerium.config.CreateServiceAccountResponse"> & {
  /**
   * The newly created service account, including any server-assigned fields.
   *
   * @generated from field: pomerium.config.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount | undefined;

  /**
   * A signed JWT credential the holder uses to authenticate as the new
   * service account. Issued only at creation time and never returned again.
   *
   * @generated from field: string jwt = 2;
   */
  jwt: string;
};

/**
 * Describes the message pomerium.config.CreateServiceAccountResponse.
 * Use `create(CreateServiceAccountResponseSchema)` to create a new message.
 */
export const CreateServiceAccountResponseSchema: GenMessage<CreateServiceAccountResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 33);

/**
 * @generated from message pomerium.config.DeleteKeyPairRequest
 */
export type DeleteKeyPairRequest = Message<"pomerium.config.DeleteKeyPairRequest"> & {
  /**
   * ID of the key pair to delete.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message pomerium.config.DeleteKeyPairRequest.
 * Use `create(DeleteKeyPairRequestSchema)` to create a new message.
 */
export const DeleteKeyPairRequestSchema: GenMessage<DeleteKeyPairRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 34);

/**
 * @generated from message pomerium.config.DeleteKeyPairResponse
 */
export type DeleteKeyPairResponse = Message<"pomerium.config.DeleteKeyPairResponse"> & {
};

/**
 * Describes the message pomerium.config.DeleteKeyPairResponse.
 * Use `create(DeleteKeyPairResponseSchema)` to create a new message.
 */
export const DeleteKeyPairResponseSchema: GenMessage<DeleteKeyPairResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 35);

/**
 * @generated from message pomerium.config.DeletePolicyRequest
 */
export type DeletePolicyRequest = Message<"pomerium.config.DeletePolicyRequest"> & {
  /**
   * ID of the policy to delete.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * For a policy with 'enforced' set to false, it may not be deleted while it
   * is assigned to a route. However if 'remove_from_any_assigned_routes' is
   * set to true, the policy will be automatically removed from any routes to
   * which it is assigned and then deleted.
   *
   * @generated from field: bool remove_from_any_assigned_routes = 2;
   */
  removeFromAnyAssignedRoutes: boolean;
};

/**
 * Describes the message pomerium.config.DeletePolicyRequest.
 * Use `create(DeletePolicyRequestSchema)` to create a new message.
 */
export const DeletePolicyRequestSchema: GenMessage<DeletePolicyRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 36);

/**
 * @generated from message pomerium.config.DeletePolicyResponse
 */
export type DeletePolicyResponse = Message<"pomerium.config.DeletePolicyResponse"> & {
};

/**
 * Describes the message pomerium.config.DeletePolicyResponse.
 * Use `create(DeletePolicyResponseSchema)` to create a new message.
 */
export const DeletePolicyResponseSchema: GenMessage<DeletePolicyResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 37);

/**
 * @generated from message pomerium.config.DeleteRouteRequest
 */
export type DeleteRouteRequest = Message<"pomerium.config.DeleteRouteRequest"> & {
  /**
   * ID of the route to delete.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message pomerium.config.DeleteRouteRequest.
 * Use `create(DeleteRouteRequestSchema)` to create a new message.
 */
export const DeleteRouteRequestSchema: GenMessage<DeleteRouteRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 38);

/**
 * @generated from message pomerium.config.DeleteRouteResponse
 */
export type DeleteRouteResponse = Message<"pomerium.config.DeleteRouteResponse"> & {
};

/**
 * Describes the message pomerium.config.DeleteRouteResponse.
 * Use `create(DeleteRouteResponseSchema)` to create a new message.
 */
export const DeleteRouteResponseSchema: GenMessage<DeleteRouteResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 39);

/**
 * @generated from message pomerium.config.DeleteServiceAccountRequest
 */
export type DeleteServiceAccountRequest = Message<"pomerium.config.DeleteServiceAccountRequest"> & {
  /**
   * ID of the service account to delete.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message pomerium.config.DeleteServiceAccountRequest.
 * Use `create(DeleteServiceAccountRequestSchema)` to create a new message.
 */
export const DeleteServiceAccountRequestSchema: GenMessage<DeleteServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 40);

/**
 * @generated from message pomerium.config.DeleteServiceAccountResponse
 */
export type DeleteServiceAccountResponse = Message<"pomerium.config.DeleteServiceAccountResponse"> & {
};

/**
 * Describes the message pomerium.config.DeleteServiceAccountResponse.
 * Use `create(DeleteServiceAccountResponseSchema)` to create a new message.
 */
export const DeleteServiceAccountResponseSchema: GenMessage<DeleteServiceAccountResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 41);

/**
 * @generated from message pomerium.config.GetKeyPairRequest
 */
export type GetKeyPairRequest = Message<"pomerium.config.GetKeyPairRequest"> & {
  /**
   * ID of the key pair to fetch.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message pomerium.config.GetKeyPairRequest.
 * Use `create(GetKeyPairRequestSchema)` to create a new message.
 */
export const GetKeyPairRequestSchema: GenMessage<GetKeyPairRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 42);

/**
 * @generated from message pomerium.config.GetKeyPairResponse
 */
export type GetKeyPairResponse = Message<"pomerium.config.GetKeyPairResponse"> & {
  /**
   * The requested key pair. Sensitive fields are stripped before return.
   *
   * @generated from field: pomerium.config.KeyPair key_pair = 1;
   */
  keyPair?: KeyPair | undefined;
};

/**
 * Describes the message pomerium.config.GetKeyPairResponse.
 * Use `create(GetKeyPairResponseSchema)` to create a new message.
 */
export const GetKeyPairResponseSchema: GenMessage<GetKeyPairResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 43);

/**
 * @generated from message pomerium.config.GetPolicyRequest
 */
export type GetPolicyRequest = Message<"pomerium.config.GetPolicyRequest"> & {
  /**
   * ID of the policy to fetch.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message pomerium.config.GetPolicyRequest.
 * Use `create(GetPolicyRequestSchema)` to create a new message.
 */
export const GetPolicyRequestSchema: GenMessage<GetPolicyRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 44);

/**
 * @generated from message pomerium.config.GetPolicyResponse
 */
export type GetPolicyResponse = Message<"pomerium.config.GetPolicyResponse"> & {
  /**
   * The requested policy.
   *
   * @generated from field: pomerium.config.Policy policy = 1;
   */
  policy?: Policy | undefined;
};

/**
 * Describes the message pomerium.config.GetPolicyResponse.
 * Use `create(GetPolicyResponseSchema)` to create a new message.
 */
export const GetPolicyResponseSchema: GenMessage<GetPolicyResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 45);

/**
 * @generated from message pomerium.config.GetRouteRequest
 */
export type GetRouteRequest = Message<"pomerium.config.GetRouteRequest"> & {
  /**
   * ID of the route to fetch.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message pomerium.config.GetRouteRequest.
 * Use `create(GetRouteRequestSchema)` to create a new message.
 */
export const GetRouteRequestSchema: GenMessage<GetRouteRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 46);

/**
 * @generated from message pomerium.config.GetRouteResponse
 */
export type GetRouteResponse = Message<"pomerium.config.GetRouteResponse"> & {
  /**
   * The requested route. Sensitive fields are stripped before return.
   *
   * @generated from field: pomerium.config.Route route = 1;
   */
  route?: Route | undefined;
};

/**
 * Describes the message pomerium.config.GetRouteResponse.
 * Use `create(GetRouteResponseSchema)` to create a new message.
 */
export const GetRouteResponseSchema: GenMessage<GetRouteResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 47);

/**
 * @generated from message pomerium.config.GetServiceAccountRequest
 */
export type GetServiceAccountRequest = Message<"pomerium.config.GetServiceAccountRequest"> & {
  /**
   * ID of the service account to fetch.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message pomerium.config.GetServiceAccountRequest.
 * Use `create(GetServiceAccountRequestSchema)` to create a new message.
 */
export const GetServiceAccountRequestSchema: GenMessage<GetServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 48);

/**
 * @generated from message pomerium.config.GetServiceAccountResponse
 */
export type GetServiceAccountResponse = Message<"pomerium.config.GetServiceAccountResponse"> & {
  /**
   * The requested service account.
   *
   * @generated from field: pomerium.config.ServiceAccount service_account = 2;
   */
  serviceAccount?: ServiceAccount | undefined;
};

/**
 * Describes the message pomerium.config.GetServiceAccountResponse.
 * Use `create(GetServiceAccountResponseSchema)` to create a new message.
 */
export const GetServiceAccountResponseSchema: GenMessage<GetServiceAccountResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 49);

/**
 * @generated from message pomerium.config.GetSettingsRequest
 */
export type GetSettingsRequest = Message<"pomerium.config.GetSettingsRequest"> & {
  /**
   * @generated from oneof pomerium.config.GetSettingsRequest.for
   */
  for: {
    /**
     * ID of the Settings record to fetch.
     *
     * @generated from field: string id = 1;
     */
    value: string;
    case: "id";
  } | {
    /**
     * Cluster ID whose Settings record should be returned.
     *
     * @generated from field: string cluster_id = 2;
     */
    value: string;
    case: "clusterId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pomerium.config.GetSettingsRequest.
 * Use `create(GetSettingsRequestSchema)` to create a new message.
 */
export const GetSettingsRequestSchema: GenMessage<GetSettingsRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 50);

/**
 * @generated from message pomerium.config.GetSettingsResponse
 */
export type GetSettingsResponse = Message<"pomerium.config.GetSettingsResponse"> & {
  /**
   * The requested Settings record. Sensitive fields are stripped before
   * return.
   *
   * @generated from field: pomerium.config.Settings settings = 1;
   */
  settings?: Settings | undefined;
};

/**
 * Describes the message pomerium.config.GetSettingsResponse.
 * Use `create(GetSettingsResponseSchema)` to create a new message.
 */
export const GetSettingsResponseSchema: GenMessage<GetSettingsResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 51);

/**
 * @generated from message pomerium.config.ListAvailableLogFieldsRequest
 */
export type ListAvailableLogFieldsRequest = Message<"pomerium.config.ListAvailableLogFieldsRequest"> & {
};

/**
 * Describes the message pomerium.config.ListAvailableLogFieldsRequest.
 * Use `create(ListAvailableLogFieldsRequestSchema)` to create a new message.
 */
export const ListAvailableLogFieldsRequestSchema: GenMessage<ListAvailableLogFieldsRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 52);

/**
 * @generated from message pomerium.config.ListAvailableLogFieldsResponse
 */
export type ListAvailableLogFieldsResponse = Message<"pomerium.config.ListAvailableLogFieldsResponse"> & {
  /**
   * All access-log field names that may appear in `Settings.access_log_fields`.
   *
   * @generated from field: repeated string available_access_log_fields = 1;
   */
  availableAccessLogFields: string[];

  /**
   * All authorize-log field names that may appear in
   * `Settings.authorize_log_fields`.
   *
   * @generated from field: repeated string available_authorize_log_fields = 2;
   */
  availableAuthorizeLogFields: string[];

  /**
   * The default access-log field set Pomerium uses when
   * `Settings.access_log_fields` is unset.
   *
   * @generated from field: repeated string default_access_log_fields = 3;
   */
  defaultAccessLogFields: string[];

  /**
   * The default authorize-log field set Pomerium uses when
   * `Settings.authorize_log_fields` is unset.
   *
   * @generated from field: repeated string default_authorize_log_fields = 4;
   */
  defaultAuthorizeLogFields: string[];
};

/**
 * Describes the message pomerium.config.ListAvailableLogFieldsResponse.
 * Use `create(ListAvailableLogFieldsResponseSchema)` to create a new message.
 */
export const ListAvailableLogFieldsResponseSchema: GenMessage<ListAvailableLogFieldsResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 53);

/**
 * @generated from message pomerium.config.ListKeyPairsRequest
 */
export type ListKeyPairsRequest = Message<"pomerium.config.ListKeyPairsRequest"> & {
  /**
   * Zero-based index of the first record to return; combine with `limit` to
   * page through results.
   *
   * @generated from field: optional uint64 offset = 1;
   */
  offset?: bigint | undefined;

  /**
   * Maximum number of records to return in this page. The server clamps
   * very large values; callers should not depend on the exact ceiling.
   *
   * @generated from field: optional uint64 limit = 2;
   */
  limit?: bigint | undefined;

  /**
   * Optional structured filter expression. The accepted shape is
   * service-specific; see the Pomerium console for examples.
   *
   * @generated from field: optional google.protobuf.Struct filter = 3;
   */
  filter?: JsonObject | undefined;

  /**
   * Sort expression, e.g. "modified_at desc". Empty for service default
   * ordering.
   *
   * @generated from field: optional string order_by = 4;
   */
  orderBy?: string | undefined;
};

/**
 * Describes the message pomerium.config.ListKeyPairsRequest.
 * Use `create(ListKeyPairsRequestSchema)` to create a new message.
 */
export const ListKeyPairsRequestSchema: GenMessage<ListKeyPairsRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 54);

/**
 * @generated from message pomerium.config.ListKeyPairsResponse
 */
export type ListKeyPairsResponse = Message<"pomerium.config.ListKeyPairsResponse"> & {
  /**
   * Page of key pairs matching the request.
   *
   * @generated from field: repeated pomerium.config.KeyPair key_pairs = 1;
   */
  keyPairs: KeyPair[];

  /**
   * Total number of key pairs that match the request across all pages,
   * independent of `limit`/`offset`.
   *
   * @generated from field: uint64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message pomerium.config.ListKeyPairsResponse.
 * Use `create(ListKeyPairsResponseSchema)` to create a new message.
 */
export const ListKeyPairsResponseSchema: GenMessage<ListKeyPairsResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 55);

/**
 * @generated from message pomerium.config.ListPoliciesRequest
 */
export type ListPoliciesRequest = Message<"pomerium.config.ListPoliciesRequest"> & {
  /**
   * Zero-based index of the first record to return.
   *
   * @generated from field: optional uint64 offset = 1;
   */
  offset?: bigint | undefined;

  /**
   * Maximum number of records to return in this page.
   *
   * @generated from field: optional uint64 limit = 2;
   */
  limit?: bigint | undefined;

  /**
   * Optional structured filter expression.
   *
   * @generated from field: optional google.protobuf.Struct filter = 3;
   */
  filter?: JsonObject | undefined;

  /**
   * Sort expression, e.g. "name asc".
   *
   * @generated from field: optional string order_by = 4;
   */
  orderBy?: string | undefined;
};

/**
 * Describes the message pomerium.config.ListPoliciesRequest.
 * Use `create(ListPoliciesRequestSchema)` to create a new message.
 */
export const ListPoliciesRequestSchema: GenMessage<ListPoliciesRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 56);

/**
 * @generated from message pomerium.config.ListPoliciesResponse
 */
export type ListPoliciesResponse = Message<"pomerium.config.ListPoliciesResponse"> & {
  /**
   * Page of policies matching the request.
   *
   * @generated from field: repeated pomerium.config.Policy policies = 1;
   */
  policies: Policy[];

  /**
   * Total number of policies matching the request across all pages.
   *
   * @generated from field: uint64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message pomerium.config.ListPoliciesResponse.
 * Use `create(ListPoliciesResponseSchema)` to create a new message.
 */
export const ListPoliciesResponseSchema: GenMessage<ListPoliciesResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 57);

/**
 * @generated from message pomerium.config.ListRoutesRequest
 */
export type ListRoutesRequest = Message<"pomerium.config.ListRoutesRequest"> & {
  /**
   * Zero-based index of the first record to return.
   *
   * @generated from field: optional uint64 offset = 1;
   */
  offset?: bigint | undefined;

  /**
   * Maximum number of records to return in this page.
   *
   * @generated from field: optional uint64 limit = 2;
   */
  limit?: bigint | undefined;

  /**
   * Optional structured filter expression.
   *
   * @generated from field: optional google.protobuf.Struct filter = 3;
   */
  filter?: JsonObject | undefined;

  /**
   * Sort expression, e.g. "name asc".
   *
   * @generated from field: optional string order_by = 4;
   */
  orderBy?: string | undefined;
};

/**
 * Describes the message pomerium.config.ListRoutesRequest.
 * Use `create(ListRoutesRequestSchema)` to create a new message.
 */
export const ListRoutesRequestSchema: GenMessage<ListRoutesRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 58);

/**
 * @generated from message pomerium.config.ListRoutesResponse
 */
export type ListRoutesResponse = Message<"pomerium.config.ListRoutesResponse"> & {
  /**
   * Page of routes matching the request.
   *
   * @generated from field: repeated pomerium.config.Route routes = 1;
   */
  routes: Route[];

  /**
   * Total number of routes matching the request across all pages.
   *
   * @generated from field: uint64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message pomerium.config.ListRoutesResponse.
 * Use `create(ListRoutesResponseSchema)` to create a new message.
 */
export const ListRoutesResponseSchema: GenMessage<ListRoutesResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 59);

/**
 * @generated from message pomerium.config.ListServiceAccountsRequest
 */
export type ListServiceAccountsRequest = Message<"pomerium.config.ListServiceAccountsRequest"> & {
  /**
   * Zero-based index of the first record to return.
   *
   * @generated from field: optional uint64 offset = 1;
   */
  offset?: bigint | undefined;

  /**
   * Maximum number of records to return in this page.
   *
   * @generated from field: optional uint64 limit = 2;
   */
  limit?: bigint | undefined;

  /**
   * Optional structured filter expression.
   *
   * @generated from field: optional google.protobuf.Struct filter = 3;
   */
  filter?: JsonObject | undefined;

  /**
   * Sort expression, e.g. "name asc".
   *
   * @generated from field: optional string order_by = 4;
   */
  orderBy?: string | undefined;
};

/**
 * Describes the message pomerium.config.ListServiceAccountsRequest.
 * Use `create(ListServiceAccountsRequestSchema)` to create a new message.
 */
export const ListServiceAccountsRequestSchema: GenMessage<ListServiceAccountsRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 60);

/**
 * @generated from message pomerium.config.ListServiceAccountsResponse
 */
export type ListServiceAccountsResponse = Message<"pomerium.config.ListServiceAccountsResponse"> & {
  /**
   * Page of service accounts matching the request.
   *
   * @generated from field: repeated pomerium.config.ServiceAccount service_accounts = 1;
   */
  serviceAccounts: ServiceAccount[];

  /**
   * Total number of service accounts matching the request across all pages.
   *
   * @generated from field: uint64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message pomerium.config.ListServiceAccountsResponse.
 * Use `create(ListServiceAccountsResponseSchema)` to create a new message.
 */
export const ListServiceAccountsResponseSchema: GenMessage<ListServiceAccountsResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 61);

/**
 * @generated from message pomerium.config.ListSettingsRequest
 */
export type ListSettingsRequest = Message<"pomerium.config.ListSettingsRequest"> & {
  /**
   * Zero-based index of the first record to return.
   *
   * @generated from field: optional uint64 offset = 1;
   */
  offset?: bigint | undefined;

  /**
   * Maximum number of records to return in this page.
   *
   * @generated from field: optional uint64 limit = 2;
   */
  limit?: bigint | undefined;

  /**
   * Optional structured filter expression.
   *
   * @generated from field: optional google.protobuf.Struct filter = 3;
   */
  filter?: JsonObject | undefined;

  /**
   * Sort expression.
   *
   * @generated from field: optional string order_by = 4;
   */
  orderBy?: string | undefined;
};

/**
 * Describes the message pomerium.config.ListSettingsRequest.
 * Use `create(ListSettingsRequestSchema)` to create a new message.
 */
export const ListSettingsRequestSchema: GenMessage<ListSettingsRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 62);

/**
 * @generated from message pomerium.config.ListSettingsResponse
 */
export type ListSettingsResponse = Message<"pomerium.config.ListSettingsResponse"> & {
  /**
   * Page of Settings records matching the request.
   *
   * @generated from field: repeated pomerium.config.Settings settings = 1;
   */
  settings: Settings[];

  /**
   * Total number of Settings records matching the request across all pages.
   *
   * @generated from field: uint64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message pomerium.config.ListSettingsResponse.
 * Use `create(ListSettingsResponseSchema)` to create a new message.
 */
export const ListSettingsResponseSchema: GenMessage<ListSettingsResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 63);

/**
 * @generated from message pomerium.config.GetServerInfoRequest
 */
export type GetServerInfoRequest = Message<"pomerium.config.GetServerInfoRequest"> & {
};

/**
 * Describes the message pomerium.config.GetServerInfoRequest.
 * Use `create(GetServerInfoRequestSchema)` to create a new message.
 */
export const GetServerInfoRequestSchema: GenMessage<GetServerInfoRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 64);

/**
 * @generated from message pomerium.config.GetServerInfoResponse
 */
export type GetServerInfoResponse = Message<"pomerium.config.GetServerInfoResponse"> & {
  /**
   * Which Pomerium build is serving this request (core, enterprise, zero).
   *
   * @generated from field: pomerium.config.ServerType server_type = 1;
   */
  serverType: ServerType;

  /**
   * The semantic version string of the running Pomerium binary.
   *
   * @generated from field: string version = 2;
   */
  version: string;
};

/**
 * Describes the message pomerium.config.GetServerInfoResponse.
 * Use `create(GetServerInfoResponseSchema)` to create a new message.
 */
export const GetServerInfoResponseSchema: GenMessage<GetServerInfoResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 65);

/**
 * @generated from message pomerium.config.UpdateKeyPairRequest
 */
export type UpdateKeyPairRequest = Message<"pomerium.config.UpdateKeyPairRequest"> & {
  /**
   * Updated key pair. The KeyPair's `id` selects which record to update; any
   * sensitive fields not present are preserved from the existing record.
   *
   * @generated from field: pomerium.config.KeyPair key_pair = 1;
   */
  keyPair?: KeyPair | undefined;

  /**
   * Optional update_mask to only update a subset of the fields.
   *
   * @generated from field: optional google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message pomerium.config.UpdateKeyPairRequest.
 * Use `create(UpdateKeyPairRequestSchema)` to create a new message.
 */
export const UpdateKeyPairRequestSchema: GenMessage<UpdateKeyPairRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 66);

/**
 * @generated from message pomerium.config.UpdateKeyPairResponse
 */
export type UpdateKeyPairResponse = Message<"pomerium.config.UpdateKeyPairResponse"> & {
  /**
   * The updated key pair, including any server-modified fields.
   *
   * @generated from field: pomerium.config.KeyPair key_pair = 1;
   */
  keyPair?: KeyPair | undefined;
};

/**
 * Describes the message pomerium.config.UpdateKeyPairResponse.
 * Use `create(UpdateKeyPairResponseSchema)` to create a new message.
 */
export const UpdateKeyPairResponseSchema: GenMessage<UpdateKeyPairResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 67);

/**
 * @generated from message pomerium.config.UpdatePolicyRequest
 */
export type UpdatePolicyRequest = Message<"pomerium.config.UpdatePolicyRequest"> & {
  /**
   * Updated policy. The Policy's `id` selects which record to update.
   *
   * @generated from field: pomerium.config.Policy policy = 1;
   */
  policy?: Policy | undefined;

  /**
   * Optional update_mask to only update a subset of the fields.
   *
   * @generated from field: optional google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message pomerium.config.UpdatePolicyRequest.
 * Use `create(UpdatePolicyRequestSchema)` to create a new message.
 */
export const UpdatePolicyRequestSchema: GenMessage<UpdatePolicyRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 68);

/**
 * @generated from message pomerium.config.UpdatePolicyResponse
 */
export type UpdatePolicyResponse = Message<"pomerium.config.UpdatePolicyResponse"> & {
  /**
   * The updated policy, including any server-modified fields.
   *
   * @generated from field: pomerium.config.Policy policy = 1;
   */
  policy?: Policy | undefined;
};

/**
 * Describes the message pomerium.config.UpdatePolicyResponse.
 * Use `create(UpdatePolicyResponseSchema)` to create a new message.
 */
export const UpdatePolicyResponseSchema: GenMessage<UpdatePolicyResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 69);

/**
 * @generated from message pomerium.config.UpdateRouteRequest
 */
export type UpdateRouteRequest = Message<"pomerium.config.UpdateRouteRequest"> & {
  /**
   * Updated route. The Route's `id` selects which record to update; any
   * sensitive fields not present are preserved from the existing record.
   *
   * @generated from field: pomerium.config.Route route = 1;
   */
  route?: Route | undefined;

  /**
   * Optional update_mask to only update a subset of the fields.
   *
   * @generated from field: optional google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message pomerium.config.UpdateRouteRequest.
 * Use `create(UpdateRouteRequestSchema)` to create a new message.
 */
export const UpdateRouteRequestSchema: GenMessage<UpdateRouteRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 70);

/**
 * @generated from message pomerium.config.UpdateRouteResponse
 */
export type UpdateRouteResponse = Message<"pomerium.config.UpdateRouteResponse"> & {
  /**
   * The updated route, including any server-modified fields.
   *
   * @generated from field: pomerium.config.Route route = 1;
   */
  route?: Route | undefined;
};

/**
 * Describes the message pomerium.config.UpdateRouteResponse.
 * Use `create(UpdateRouteResponseSchema)` to create a new message.
 */
export const UpdateRouteResponseSchema: GenMessage<UpdateRouteResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 71);

/**
 * @generated from message pomerium.config.UpdateServiceAccountRequest
 */
export type UpdateServiceAccountRequest = Message<"pomerium.config.UpdateServiceAccountRequest"> & {
  /**
   * Updated service account. The ServiceAccount's `id` selects which record
   * to update.
   *
   * @generated from field: pomerium.config.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount | undefined;

  /**
   * Optional update_mask to only update a subset of the fields.
   *
   * @generated from field: optional google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message pomerium.config.UpdateServiceAccountRequest.
 * Use `create(UpdateServiceAccountRequestSchema)` to create a new message.
 */
export const UpdateServiceAccountRequestSchema: GenMessage<UpdateServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 72);

/**
 * @generated from message pomerium.config.UpdateServiceAccountResponse
 */
export type UpdateServiceAccountResponse = Message<"pomerium.config.UpdateServiceAccountResponse"> & {
  /**
   * The updated service account.
   *
   * @generated from field: pomerium.config.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount | undefined;

  /**
   * A newly issued JWT for the service account.
   *
   * @generated from field: string jwt = 2;
   */
  jwt: string;
};

/**
 * Describes the message pomerium.config.UpdateServiceAccountResponse.
 * Use `create(UpdateServiceAccountResponseSchema)` to create a new message.
 */
export const UpdateServiceAccountResponseSchema: GenMessage<UpdateServiceAccountResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 73);

/**
 * @generated from message pomerium.config.UpdateSettingsRequest
 */
export type UpdateSettingsRequest = Message<"pomerium.config.UpdateSettingsRequest"> & {
  /**
   * Updated Settings record. The Settings `id` selects which record to
   * update; sensitive fields not present in the request are preserved from
   * the existing record.
   *
   * @generated from field: pomerium.config.Settings settings = 1;
   */
  settings?: Settings | undefined;

  /**
   * Optional update_mask to only update a subset of the fields.
   *
   * @generated from field: optional google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message pomerium.config.UpdateSettingsRequest.
 * Use `create(UpdateSettingsRequestSchema)` to create a new message.
 */
export const UpdateSettingsRequestSchema: GenMessage<UpdateSettingsRequest> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 74);

/**
 * @generated from message pomerium.config.UpdateSettingsResponse
 */
export type UpdateSettingsResponse = Message<"pomerium.config.UpdateSettingsResponse"> & {
  /**
   * The updated Settings record, including any server-modified fields.
   *
   * @generated from field: pomerium.config.Settings settings = 1;
   */
  settings?: Settings | undefined;
};

/**
 * Describes the message pomerium.config.UpdateSettingsResponse.
 * Use `create(UpdateSettingsResponseSchema)` to create a new message.
 */
export const UpdateSettingsResponseSchema: GenMessage<UpdateSettingsResponse> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 75);

/**
 * [#next-free-field: 27]
 *
 * @generated from message pomerium.config.HealthCheck
 */
export type HealthCheck = Message<"pomerium.config.HealthCheck"> & {
  /**
   * The time to wait for a health check response. If the timeout is reached the
   * health check attempt will be considered a failure.
   *
   * @generated from field: google.protobuf.Duration timeout = 1;
   */
  timeout?: Duration | undefined;

  /**
   * The interval between health checks.
   *
   * @generated from field: google.protobuf.Duration interval = 2;
   */
  interval?: Duration | undefined;

  /**
   * An optional jitter amount in milliseconds. If specified, Envoy will start health
   * checking after for a random time in ms between 0 and initial_jitter. This only
   * applies to the first health check.
   *
   * @generated from field: google.protobuf.Duration initial_jitter = 20;
   */
  initialJitter?: Duration | undefined;

  /**
   * An optional jitter amount in milliseconds. If specified, during every
   * interval Envoy will add interval_jitter to the wait time.
   *
   * @generated from field: google.protobuf.Duration interval_jitter = 3;
   */
  intervalJitter?: Duration | undefined;

  /**
   * An optional jitter amount as a percentage of interval_ms. If specified,
   * during every interval Envoy will add ``interval_ms`` *
   * ``interval_jitter_percent`` / 100 to the wait time.
   *
   * If interval_jitter_ms and interval_jitter_percent are both set, both of
   * them will be used to increase the wait time.
   *
   * @generated from field: uint32 interval_jitter_percent = 18;
   */
  intervalJitterPercent: number;

  /**
   * The number of unhealthy health checks required before a host is marked
   * unhealthy. Note that for ``http`` health checking if a host responds with a code not in
   * :ref:`expected_statuses <envoy_v3_api_field_config.core.v3.HealthCheck.HttpHealthCheck.expected_statuses>`
   * or :ref:`retriable_statuses <envoy_v3_api_field_config.core.v3.HealthCheck.HttpHealthCheck.retriable_statuses>`,
   * this threshold is ignored and the host is considered immediately unhealthy.
   *
   * @generated from field: google.protobuf.UInt32Value unhealthy_threshold = 4;
   */
  unhealthyThreshold?: number | undefined;

  /**
   * The number of healthy health checks required before a host is marked
   * healthy. Note that during startup, only a single successful health check is
   * required to mark a host healthy.
   *
   * @generated from field: google.protobuf.UInt32Value healthy_threshold = 5;
   */
  healthyThreshold?: number | undefined;

  /**
   * [#not-implemented-hide:] Non-serving port for health checking.
   *
   * @generated from field: google.protobuf.UInt32Value alt_port = 6;
   */
  altPort?: number | undefined;

  /**
   * Reuse health check connection between health checks. Default is true.
   *
   * @generated from field: google.protobuf.BoolValue reuse_connection = 7;
   */
  reuseConnection?: boolean | undefined;

  /**
   * @generated from oneof pomerium.config.HealthCheck.health_checker
   */
  healthChecker: {
    /**
     * HTTP health check.
     *
     * @generated from field: pomerium.config.HealthCheck.HttpHealthCheck http_health_check = 8;
     */
    value: HealthCheck_HttpHealthCheck;
    case: "httpHealthCheck";
  } | {
    /**
     * TCP health check.
     *
     * @generated from field: pomerium.config.HealthCheck.TcpHealthCheck tcp_health_check = 9;
     */
    value: HealthCheck_TcpHealthCheck;
    case: "tcpHealthCheck";
  } | {
    /**
     * gRPC health check.
     *
     * @generated from field: pomerium.config.HealthCheck.GrpcHealthCheck grpc_health_check = 11;
     */
    value: HealthCheck_GrpcHealthCheck;
    case: "grpcHealthCheck";
  } | { case: undefined; value?: undefined };

  /**
   * The "no traffic interval" is a special health check interval that is used when a cluster has
   * never had traffic routed to it. This lower interval allows cluster information to be kept up to
   * date, without sending a potentially large amount of active health checking traffic for no
   * reason. Once a cluster has been used for traffic routing, Envoy will shift back to using the
   * standard health check interval that is defined. Note that this interval takes precedence over
   * any other.
   *
   * The default value for "no traffic interval" is 60 seconds.
   *
   * @generated from field: google.protobuf.Duration no_traffic_interval = 12;
   */
  noTrafficInterval?: Duration | undefined;

  /**
   * The "no traffic healthy interval" is a special health check interval that
   * is used for hosts that are currently passing active health checking
   * (including new hosts) when the cluster has received no traffic.
   *
   * This is useful for when we want to send frequent health checks with
   * ``no_traffic_interval`` but then revert to lower frequency ``no_traffic_healthy_interval`` once
   * a host in the cluster is marked as healthy.
   *
   * Once a cluster has been used for traffic routing, Envoy will shift back to using the
   * standard health check interval that is defined.
   *
   * If no_traffic_healthy_interval is not set, it will default to the
   * no traffic interval and send that interval regardless of health state.
   *
   * @generated from field: google.protobuf.Duration no_traffic_healthy_interval = 24;
   */
  noTrafficHealthyInterval?: Duration | undefined;

  /**
   * The "unhealthy interval" is a health check interval that is used for hosts that are marked as
   * unhealthy. As soon as the host is marked as healthy, Envoy will shift back to using the
   * standard health check interval that is defined.
   *
   * The default value for "unhealthy interval" is the same as "interval".
   *
   * @generated from field: google.protobuf.Duration unhealthy_interval = 14;
   */
  unhealthyInterval?: Duration | undefined;

  /**
   * The "unhealthy edge interval" is a special health check interval that is used for the first
   * health check right after a host is marked as unhealthy. For subsequent health checks
   * Envoy will shift back to using either "unhealthy interval" if present or the standard health
   * check interval that is defined.
   *
   * The default value for "unhealthy edge interval" is the same as "unhealthy interval".
   *
   * @generated from field: google.protobuf.Duration unhealthy_edge_interval = 15;
   */
  unhealthyEdgeInterval?: Duration | undefined;

  /**
   * The "healthy edge interval" is a special health check interval that is used for the first
   * health check right after a host is marked as healthy. For subsequent health checks
   * Envoy will shift back to using the standard health check interval that is defined.
   *
   * The default value for "healthy edge interval" is the same as the default interval.
   *
   * @generated from field: google.protobuf.Duration healthy_edge_interval = 16;
   */
  healthyEdgeInterval?: Duration | undefined;

  /**
   * If set to true, health check failure events will always be logged. If set to false, only the
   * initial health check failure event will be logged.
   * The default value is false.
   *
   * @generated from field: bool always_log_health_check_failures = 19;
   */
  alwaysLogHealthCheckFailures: boolean;

  /**
   * If set to true, health check success events will always be logged. If set to false, only host addition event will be logged
   * if it is the first successful health check, or if the healthy threshold is reached.
   * The default value is false.
   *
   * @generated from field: bool always_log_health_check_success = 26;
   */
  alwaysLogHealthCheckSuccess: boolean;

  /**
   * Optional key/value pairs that will be used to match a transport socket from those specified in the cluster's
   * :ref:`tranport socket matches <envoy_v3_api_field_config.cluster.v3.Cluster.transport_socket_matches>`.
   * For example, the following match criteria
   *
   * .. code-block:: yaml
   *
   *  transport_socket_match_criteria:
   *    useMTLS: true
   *
   * Will match the following :ref:`cluster socket match <envoy_v3_api_msg_config.cluster.v3.Cluster.TransportSocketMatch>`
   *
   * .. code-block:: yaml
   *
   *  transport_socket_matches:
   *  - name: "useMTLS"
   *    match:
   *      useMTLS: true
   *    transport_socket:
   *      name: envoy.transport_sockets.tls
   *      config: { ... } # tls socket configuration
   *
   * If this field is set, then for health checks it will supersede an entry of ``envoy.transport_socket`` in the
   * :ref:`LbEndpoint.Metadata <envoy_v3_api_field_config.endpoint.v3.LbEndpoint.metadata>`.
   * This allows using different transport socket capabilities for health checking versus proxying to the
   * endpoint.
   *
   * If the key/values pairs specified do not match any
   * :ref:`transport socket matches <envoy_v3_api_field_config.cluster.v3.Cluster.transport_socket_matches>`,
   * the cluster's :ref:`transport socket <envoy_v3_api_field_config.cluster.v3.Cluster.transport_socket>`
   * will be used for health check socket configuration.
   *
   * @generated from field: google.protobuf.Struct transport_socket_match_criteria = 23;
   */
  transportSocketMatchCriteria?: JsonObject | undefined;
};

/**
 * Describes the message pomerium.config.HealthCheck.
 * Use `create(HealthCheckSchema)` to create a new message.
 */
export const HealthCheckSchema: GenMessage<HealthCheck> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 76);

/**
 * @generated from message pomerium.config.HealthCheck.HealthStatusSet
 */
export type HealthCheck_HealthStatusSet = Message<"pomerium.config.HealthCheck.HealthStatusSet"> & {
  /**
   * An order-independent set of health status.
   *
   * @generated from field: repeated pomerium.config.HealthCheck.HealthStatus statuses = 1;
   */
  statuses: HealthCheck_HealthStatus[];
};

/**
 * Describes the message pomerium.config.HealthCheck.HealthStatusSet.
 * Use `create(HealthCheck_HealthStatusSetSchema)` to create a new message.
 */
export const HealthCheck_HealthStatusSetSchema: GenMessage<HealthCheck_HealthStatusSet> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 76, 0);

/**
 * @generated from message pomerium.config.HealthCheck.Int64Range
 */
export type HealthCheck_Int64Range = Message<"pomerium.config.HealthCheck.Int64Range"> & {
  /**
   * start of the range (inclusive)
   *
   * @generated from field: int64 start = 1;
   */
  start: bigint;

  /**
   * end of the range (exclusive)
   *
   * @generated from field: int64 end = 2;
   */
  end: bigint;
};

/**
 * Describes the message pomerium.config.HealthCheck.Int64Range.
 * Use `create(HealthCheck_Int64RangeSchema)` to create a new message.
 */
export const HealthCheck_Int64RangeSchema: GenMessage<HealthCheck_Int64Range> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 76, 1);

/**
 * Describes the encoding of the payload bytes in the payload.
 *
 * @generated from message pomerium.config.HealthCheck.Payload
 */
export type HealthCheck_Payload = Message<"pomerium.config.HealthCheck.Payload"> & {
  /**
   * @generated from oneof pomerium.config.HealthCheck.Payload.payload
   */
  payload: {
    /**
     * Hex encoded payload. E.g., "000000FF".
     *
     * @generated from field: string text = 1;
     */
    value: string;
    case: "text";
  } | {
    /**
     * Binary payload.
     *
     * @generated from field: bytes binary = 2;
     */
    value: Uint8Array;
    case: "binary";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pomerium.config.HealthCheck.Payload.
 * Use `create(HealthCheck_PayloadSchema)` to create a new message.
 */
export const HealthCheck_PayloadSchema: GenMessage<HealthCheck_Payload> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 76, 2);

/**
 * [#next-free-field: 15]
 *
 * @generated from message pomerium.config.HealthCheck.HttpHealthCheck
 */
export type HealthCheck_HttpHealthCheck = Message<"pomerium.config.HealthCheck.HttpHealthCheck"> & {
  /**
   * The value of the host header in the HTTP health check request. If
   * left empty (default value), the name of the cluster this health check is associated
   * with will be used. The host header can be customized for a specific endpoint by setting the
   * :ref:`hostname <envoy_v3_api_field_config.endpoint.v3.Endpoint.HealthCheckConfig.hostname>` field.
   *
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * Specifies the HTTP path that will be requested during health checking. For example
   * ``/healthcheck``.
   *
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * HTTP specific payload to be sent as the request body during health checking.
   * If specified, the method should support a request body (POST, PUT, PATCH, etc.).
   *
   * @generated from field: pomerium.config.HealthCheck.Payload send = 3;
   */
  send?: HealthCheck_Payload | undefined;

  /**
   * Specifies a list of HTTP expected responses to match in the first ``response_buffer_size`` bytes of the response body.
   * If it is set, both the expected response check and status code determine the health check.
   * When checking the response, “fuzzy” matching is performed such that each payload block must be found,
   * and in the order specified, but not necessarily contiguous.
   *
   * .. note::
   *
   *   It is recommended to set ``response_buffer_size`` based on the total Payload size for efficiency.
   *   The default buffer size is 1024 bytes when it is not set.
   *
   * @generated from field: repeated pomerium.config.HealthCheck.Payload receive = 4;
   */
  receive: HealthCheck_Payload[];

  /**
   * Specifies the size of response buffer in bytes that is used to Payload match.
   * The default value is 1024. Setting to 0 implies that the Payload will be matched against the entire response.
   *
   * @generated from field: google.protobuf.UInt64Value response_buffer_size = 14;
   */
  responseBufferSize?: bigint | undefined;

  /**
   * Specifies a list of HTTP headers that should be removed from each request that is sent to the
   * health checked cluster.
   *
   * @generated from field: repeated string request_headers_to_remove = 8;
   */
  requestHeadersToRemove: string[];

  /**
   * Specifies a list of HTTP response statuses considered healthy. If provided, replaces default
   * 200-only policy - 200 must be included explicitly as needed. Ranges follow half-open
   * semantics of :ref:`Int64Range <envoy_v3_api_msg_type.v3.Int64Range>`. The start and end of each
   * range are required. Only statuses in the range [100, 600) are allowed.
   *
   * @generated from field: repeated pomerium.config.HealthCheck.Int64Range expected_statuses = 9;
   */
  expectedStatuses: HealthCheck_Int64Range[];

  /**
   * Specifies a list of HTTP response statuses considered retriable. If provided, responses in this range
   * will count towards the configured :ref:`unhealthy_threshold <envoy_v3_api_field_config.core.v3.HealthCheck.unhealthy_threshold>`,
   * but will not result in the host being considered immediately unhealthy. Ranges follow half-open semantics of
   * :ref:`Int64Range <envoy_v3_api_msg_type.v3.Int64Range>`. The start and end of each range are required.
   * Only statuses in the range [100, 600) are allowed. The :ref:`expected_statuses <envoy_v3_api_field_config.core.v3.HealthCheck.HttpHealthCheck.expected_statuses>`
   * field takes precedence for any range overlaps with this field i.e. if status code 200 is both retriable and expected, a 200 response will
   * be considered a successful health check. By default all responses not in
   * :ref:`expected_statuses <envoy_v3_api_field_config.core.v3.HealthCheck.HttpHealthCheck.expected_statuses>` will result in
   * the host being considered immediately unhealthy i.e. if status code 200 is expected and there are no configured retriable statuses, any
   * non-200 response will result in the host being marked unhealthy.
   *
   * @generated from field: repeated pomerium.config.HealthCheck.Int64Range retriable_statuses = 12;
   */
  retriableStatuses: HealthCheck_Int64Range[];

  /**
   * Use specified application protocol for health checks.
   *
   * @generated from field: pomerium.config.HealthCheck.CodecClientType codec_client_type = 10;
   */
  codecClientType: HealthCheck_CodecClientType;
};

/**
 * Describes the message pomerium.config.HealthCheck.HttpHealthCheck.
 * Use `create(HealthCheck_HttpHealthCheckSchema)` to create a new message.
 */
export const HealthCheck_HttpHealthCheckSchema: GenMessage<HealthCheck_HttpHealthCheck> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 76, 3);

/**
 * @generated from message pomerium.config.HealthCheck.TcpHealthCheck
 */
export type HealthCheck_TcpHealthCheck = Message<"pomerium.config.HealthCheck.TcpHealthCheck"> & {
  /**
   * Empty payloads imply a connect-only health check.
   *
   * @generated from field: pomerium.config.HealthCheck.Payload send = 1;
   */
  send?: HealthCheck_Payload | undefined;

  /**
   * When checking the response, “fuzzy” matching is performed such that each
   * payload block must be found, and in the order specified, but not
   * necessarily contiguous.
   *
   * @generated from field: repeated pomerium.config.HealthCheck.Payload receive = 2;
   */
  receive: HealthCheck_Payload[];
};

/**
 * Describes the message pomerium.config.HealthCheck.TcpHealthCheck.
 * Use `create(HealthCheck_TcpHealthCheckSchema)` to create a new message.
 */
export const HealthCheck_TcpHealthCheckSchema: GenMessage<HealthCheck_TcpHealthCheck> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 76, 4);

/**
 * `grpc.health.v1.Health
 * <https://github.com/grpc/grpc/blob/master/src/proto/grpc/health/v1/health.proto>`_-based
 * healthcheck. See `gRPC doc <https://github.com/grpc/grpc/blob/master/doc/health-checking.md>`_
 * for details.
 *
 * @generated from message pomerium.config.HealthCheck.GrpcHealthCheck
 */
export type HealthCheck_GrpcHealthCheck = Message<"pomerium.config.HealthCheck.GrpcHealthCheck"> & {
  /**
   * An optional service name parameter which will be sent to gRPC service in
   * `grpc.health.v1.HealthCheckRequest
   * <https://github.com/grpc/grpc/blob/master/src/proto/grpc/health/v1/health.proto#L20>`_.
   * message. See `gRPC health-checking overview
   * <https://github.com/grpc/grpc/blob/master/doc/health-checking.md>`_ for
   * more information.
   *
   * @generated from field: string service_name = 1;
   */
  serviceName: string;

  /**
   * The value of the :authority header in the gRPC health check request. If
   * left empty (default value), the name of the cluster this health check is
   * associated with will be used. The authority header can be customized for
   * a specific endpoint by setting the :ref:`hostname
   * <envoy_v3_api_field_config.endpoint.v3.Endpoint.HealthCheckConfig.hostname>`
   * field.
   *
   * @generated from field: string authority = 2;
   */
  authority: string;
};

/**
 * Describes the message pomerium.config.HealthCheck.GrpcHealthCheck.
 * Use `create(HealthCheck_GrpcHealthCheckSchema)` to create a new message.
 */
export const HealthCheck_GrpcHealthCheckSchema: GenMessage<HealthCheck_GrpcHealthCheck> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 76, 5);

/**
 * Endpoint health status.
 *
 * @generated from enum pomerium.config.HealthCheck.HealthStatus
 */
export enum HealthCheck_HealthStatus {
  /**
   * The health status is not known. This is interpreted by Envoy as ``HEALTHY``.
   *
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Healthy.
   *
   * @generated from enum value: HEALTHY = 1;
   */
  HEALTHY = 1,

  /**
   * Unhealthy.
   *
   * @generated from enum value: UNHEALTHY = 2;
   */
  UNHEALTHY = 2,

  /**
   * Connection draining in progress. E.g.,
   * `<https://aws.amazon.com/blogs/aws/elb-connection-draining-remove-instances-from-service-with-care/>`_
   * or
   * `<https://cloud.google.com/compute/docs/load-balancing/enabling-connection-draining>`_.
   * This is interpreted by Envoy as ``UNHEALTHY``.
   *
   * @generated from enum value: DRAINING = 3;
   */
  DRAINING = 3,

  /**
   * Health check timed out. This is part of HDS and is interpreted by Envoy as
   * ``UNHEALTHY``.
   *
   * @generated from enum value: TIMEOUT = 4;
   */
  TIMEOUT = 4,

  /**
   * Degraded.
   *
   * @generated from enum value: DEGRADED = 5;
   */
  DEGRADED = 5,
}

/**
 * Describes the enum pomerium.config.HealthCheck.HealthStatus.
 */
export const HealthCheck_HealthStatusSchema: GenEnum<HealthCheck_HealthStatus> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 76, 0);

/**
 * HTTP version used to phrase the health-check request to the upstream.
 *
 * @generated from enum pomerium.config.HealthCheck.CodecClientType
 */
export enum HealthCheck_CodecClientType {
  /**
   * Use HTTP/1.1 framing.
   *
   * @generated from enum value: HTTP1 = 0;
   */
  HTTP1 = 0,

  /**
   * Use HTTP/2 framing.
   *
   * @generated from enum value: HTTP2 = 1;
   */
  HTTP2 = 1,

  /**
   * Use HTTP/3 framing.
   *
   * @generated from enum value: HTTP3 = 2;
   */
  HTTP3 = 2,
}

/**
 * Describes the enum pomerium.config.HealthCheck.CodecClientType.
 */
export const HealthCheck_CodecClientTypeSchema: GenEnum<HealthCheck_CodecClientType> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 76, 1);

/**
 * @generated from message pomerium.config.OutlierDetection
 */
export type OutlierDetection = Message<"pomerium.config.OutlierDetection"> & {
  /**
   * The number of consecutive server-side error responses (for HTTP traffic,
   * 5xx responses; for TCP traffic, connection failures; for Redis, failure to
   * respond PONG; etc.) before a consecutive 5xx ejection occurs. Defaults to 5.
   *
   * @generated from field: google.protobuf.UInt32Value consecutive_5xx = 1;
   */
  consecutive5xx?: number | undefined;

  /**
   * The time interval between ejection analysis sweeps. This can result in
   * both new ejections as well as hosts being returned to service. Defaults
   * to 10000ms or 10s.
   *
   * @generated from field: google.protobuf.Duration interval = 2;
   */
  interval?: Duration | undefined;

  /**
   * The base time that a host is ejected for. The real time is equal to the
   * base time multiplied by the number of times the host has been ejected and is
   * capped by :ref:`max_ejection_time<envoy_v3_api_field_config.cluster.v3.OutlierDetection.max_ejection_time>`.
   * Defaults to 30000ms or 30s.
   *
   * @generated from field: google.protobuf.Duration base_ejection_time = 3;
   */
  baseEjectionTime?: Duration | undefined;

  /**
   * The maximum % of an upstream cluster that can be ejected due to outlier detection. Defaults to 10% .
   * Will eject at least one host regardless of the value if :ref:`always_eject_one_host<envoy_v3_api_field_config.cluster.v3.OutlierDetection.always_eject_one_host>` is enabled.
   *
   * @generated from field: google.protobuf.UInt32Value max_ejection_percent = 4;
   */
  maxEjectionPercent?: number | undefined;

  /**
   * The % chance that a host will be actually ejected when an outlier status
   * is detected through consecutive 5xx. This setting can be used to disable
   * ejection or to ramp it up slowly. Defaults to 100.
   *
   * @generated from field: google.protobuf.UInt32Value enforcing_consecutive_5xx = 5;
   */
  enforcingConsecutive5xx?: number | undefined;

  /**
   * The % chance that a host will be actually ejected when an outlier status
   * is detected through success rate statistics. This setting can be used to
   * disable ejection or to ramp it up slowly. Defaults to 100.
   *
   * @generated from field: google.protobuf.UInt32Value enforcing_success_rate = 6;
   */
  enforcingSuccessRate?: number | undefined;

  /**
   * The number of hosts in a cluster that must have enough request volume to
   * detect success rate outliers. If the number of hosts is less than this
   * setting, outlier detection via success rate statistics is not performed
   * for any host in the cluster. Defaults to 5.
   *
   * @generated from field: google.protobuf.UInt32Value success_rate_minimum_hosts = 7;
   */
  successRateMinimumHosts?: number | undefined;

  /**
   * The minimum number of total requests that must be collected in one
   * interval (as defined by the interval duration above) to include this host
   * in success rate based outlier detection. If the volume is lower than this
   * setting, outlier detection via success rate statistics is not performed
   * for that host. Defaults to 100.
   *
   * @generated from field: google.protobuf.UInt32Value success_rate_request_volume = 8;
   */
  successRateRequestVolume?: number | undefined;

  /**
   * This factor is used to determine the ejection threshold for success rate
   * outlier ejection. The ejection threshold is the difference between the
   * mean success rate, and the product of this factor and the standard
   * deviation of the mean success rate: mean - (stdev *
   * success_rate_stdev_factor). This factor is divided by a thousand to get a
   * double. That is, if the desired factor is 1.9, the runtime value should
   * be 1900. Defaults to 1900.
   *
   * @generated from field: google.protobuf.UInt32Value success_rate_stdev_factor = 9;
   */
  successRateStdevFactor?: number | undefined;

  /**
   * The number of consecutive gateway failures (502, 503, 504 status codes)
   * before a consecutive gateway failure ejection occurs. Defaults to 5.
   *
   * @generated from field: google.protobuf.UInt32Value consecutive_gateway_failure = 10;
   */
  consecutiveGatewayFailure?: number | undefined;

  /**
   * The % chance that a host will be actually ejected when an outlier status
   * is detected through consecutive gateway failures. This setting can be
   * used to disable ejection or to ramp it up slowly. Defaults to 0.
   *
   * @generated from field: google.protobuf.UInt32Value enforcing_consecutive_gateway_failure = 11;
   */
  enforcingConsecutiveGatewayFailure?: number | undefined;

  /**
   * Determines whether to distinguish local origin failures from external errors. If set to true
   * the following configuration parameters are taken into account:
   * :ref:`consecutive_local_origin_failure<envoy_v3_api_field_config.cluster.v3.OutlierDetection.consecutive_local_origin_failure>`,
   * :ref:`enforcing_consecutive_local_origin_failure<envoy_v3_api_field_config.cluster.v3.OutlierDetection.enforcing_consecutive_local_origin_failure>`
   * and
   * :ref:`enforcing_local_origin_success_rate<envoy_v3_api_field_config.cluster.v3.OutlierDetection.enforcing_local_origin_success_rate>`.
   * Defaults to false.
   *
   * @generated from field: bool split_external_local_origin_errors = 12;
   */
  splitExternalLocalOriginErrors: boolean;

  /**
   * The number of consecutive locally originated failures before ejection
   * occurs. Defaults to 5. Parameter takes effect only when
   * :ref:`split_external_local_origin_errors<envoy_v3_api_field_config.cluster.v3.OutlierDetection.split_external_local_origin_errors>`
   * is set to true.
   *
   * @generated from field: google.protobuf.UInt32Value consecutive_local_origin_failure = 13;
   */
  consecutiveLocalOriginFailure?: number | undefined;

  /**
   * The % chance that a host will be actually ejected when an outlier status
   * is detected through consecutive locally originated failures. This setting can be
   * used to disable ejection or to ramp it up slowly. Defaults to 100.
   * Parameter takes effect only when
   * :ref:`split_external_local_origin_errors<envoy_v3_api_field_config.cluster.v3.OutlierDetection.split_external_local_origin_errors>`
   * is set to true.
   *
   * @generated from field: google.protobuf.UInt32Value enforcing_consecutive_local_origin_failure = 14;
   */
  enforcingConsecutiveLocalOriginFailure?: number | undefined;

  /**
   * The % chance that a host will be actually ejected when an outlier status
   * is detected through success rate statistics for locally originated errors.
   * This setting can be used to disable ejection or to ramp it up slowly. Defaults to 100.
   * Parameter takes effect only when
   * :ref:`split_external_local_origin_errors<envoy_v3_api_field_config.cluster.v3.OutlierDetection.split_external_local_origin_errors>`
   * is set to true.
   *
   * @generated from field: google.protobuf.UInt32Value enforcing_local_origin_success_rate = 15;
   */
  enforcingLocalOriginSuccessRate?: number | undefined;

  /**
   * The failure percentage to use when determining failure percentage-based outlier detection. If
   * the failure percentage of a given host is greater than or equal to this value, it will be
   * ejected. Defaults to 85.
   *
   * @generated from field: google.protobuf.UInt32Value failure_percentage_threshold = 16;
   */
  failurePercentageThreshold?: number | undefined;

  /**
   * The % chance that a host will be actually ejected when an outlier status is detected through
   * failure percentage statistics. This setting can be used to disable ejection or to ramp it up
   * slowly. Defaults to 0.
   *
   * [#next-major-version: setting this without setting failure_percentage_threshold should be
   * invalid in v4.]
   *
   * @generated from field: google.protobuf.UInt32Value enforcing_failure_percentage = 17;
   */
  enforcingFailurePercentage?: number | undefined;

  /**
   * The % chance that a host will be actually ejected when an outlier status is detected through
   * local-origin failure percentage statistics. This setting can be used to disable ejection or to
   * ramp it up slowly. Defaults to 0.
   *
   * @generated from field: google.protobuf.UInt32Value enforcing_failure_percentage_local_origin = 18;
   */
  enforcingFailurePercentageLocalOrigin?: number | undefined;

  /**
   * The minimum number of hosts in a cluster in order to perform failure percentage-based ejection.
   * If the total number of hosts in the cluster is less than this value, failure percentage-based
   * ejection will not be performed. Defaults to 5.
   *
   * @generated from field: google.protobuf.UInt32Value failure_percentage_minimum_hosts = 19;
   */
  failurePercentageMinimumHosts?: number | undefined;

  /**
   * The minimum number of total requests that must be collected in one interval (as defined by the
   * interval duration above) to perform failure percentage-based ejection for this host. If the
   * volume is lower than this setting, failure percentage-based ejection will not be performed for
   * this host. Defaults to 50.
   *
   * @generated from field: google.protobuf.UInt32Value failure_percentage_request_volume = 20;
   */
  failurePercentageRequestVolume?: number | undefined;

  /**
   * The maximum time that a host is ejected for. See :ref:`base_ejection_time<envoy_v3_api_field_config.cluster.v3.OutlierDetection.base_ejection_time>`
   * for more information. If not specified, the default value (300000ms or 300s) or
   * :ref:`base_ejection_time<envoy_v3_api_field_config.cluster.v3.OutlierDetection.base_ejection_time>` value is applied, whatever is larger.
   *
   * @generated from field: google.protobuf.Duration max_ejection_time = 21;
   */
  maxEjectionTime?: Duration | undefined;

  /**
   * The maximum amount of jitter to add to the ejection time, in order to prevent
   * a 'thundering herd' effect where all proxies try to reconnect to host at the same time.
   * See :ref:`max_ejection_time_jitter<envoy_v3_api_field_config.cluster.v3.OutlierDetection.base_ejection_time>`
   * Defaults to 0s.
   *
   * @generated from field: google.protobuf.Duration max_ejection_time_jitter = 22;
   */
  maxEjectionTimeJitter?: Duration | undefined;

  /**
   * If active health checking is enabled and a host is ejected by outlier detection, a successful active health check
   * unejects the host by default and considers it as healthy. Unejection also clears all the outlier detection counters.
   * To change this default behavior set this config to ``false`` where active health checking will not uneject the host.
   * Defaults to true.
   *
   * @generated from field: google.protobuf.BoolValue successful_active_health_check_uneject_host = 23;
   */
  successfulActiveHealthCheckUnejectHost?: boolean | undefined;

  /**
   * If enabled, at least one host is ejected regardless of the value of :ref:`max_ejection_percent<envoy_v3_api_field_config.cluster.v3.OutlierDetection.max_ejection_percent>`.
   * Defaults to false.
   *
   * @generated from field: google.protobuf.BoolValue always_eject_one_host = 25;
   */
  alwaysEjectOneHost?: boolean | undefined;
};

/**
 * Describes the message pomerium.config.OutlierDetection.
 * Use `create(OutlierDetectionSchema)` to create a new message.
 */
export const OutlierDetectionSchema: GenMessage<OutlierDetection> = /*@__PURE__*/
  messageDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 77);

/**
 * Format used for the `iss` claim of JWTs Pomerium issues for upstream
 * requests.
 *
 * @generated from enum pomerium.config.IssuerFormat
 */
export enum IssuerFormat {
  /**
   * Issuer strings will be the hostname of the route, with no scheme or
   * trailing slash.
   *
   * @generated from enum value: IssuerHostOnly = 0;
   */
  IssuerHostOnly = 0,

  /**
   * Issuer strings will be a complete URI, including the scheme and ending
   * with a trailing slash.
   *
   * @generated from enum value: IssuerURI = 1;
   */
  IssuerURI = 1,
}

/**
 * Describes the enum pomerium.config.IssuerFormat.
 */
export const IssuerFormatSchema: GenEnum<IssuerFormat> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 0);

/**
 * Controls how HTTP bearer token authentication is handled.
 *
 * @generated from enum pomerium.config.BearerTokenFormat
 */
export enum BearerTokenFormat {
  /**
   * @generated from enum value: BEARER_TOKEN_FORMAT_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * The default behavior is to pass bearer tokens to upstream applications
   * without interpreting them.
   *
   * @generated from enum value: BEARER_TOKEN_FORMAT_DEFAULT = 1;
   */
  DEFAULT = 1,

  /**
   * The bearer token will be interpreted as an IdP-issued access token.
   *
   * @generated from enum value: BEARER_TOKEN_FORMAT_IDP_ACCESS_TOKEN = 2;
   */
  IDP_ACCESS_TOKEN = 2,

  /**
   * The bearer token will be interpreted as an IdP-issued identity token.
   *
   * @generated from enum value: BEARER_TOKEN_FORMAT_IDP_IDENTITY_TOKEN = 3;
   */
  IDP_IDENTITY_TOKEN = 3,
}

/**
 * Describes the enum pomerium.config.BearerTokenFormat.
 */
export const BearerTokenFormatSchema: GenEnum<BearerTokenFormat> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 1);

/**
 * Action to take when Envoy receives client request with header names containing underscore characters.
 *
 * @generated from enum pomerium.config.HeadersWithUnderscoresAction
 */
export enum HeadersWithUnderscoresAction {
  /**
   * @generated from enum value: HEADERS_WITH_UNDERSCORES_ACTION_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Allow headers with underscores.
   *
   * @generated from enum value: HEADERS_WITH_UNDERSCORES_ACTION_ALLOW = 1;
   */
  ALLOW = 1,

  /**
   * ⁣Reject client request. This is the default behavior.
   *
   * @generated from enum value: HEADERS_WITH_UNDERSCORES_ACTION_REJECT_REQUEST = 2;
   */
  REJECT_REQUEST = 2,

  /**
   * Drop the client header with name containing underscores.
   *
   * @generated from enum value: HEADERS_WITH_UNDERSCORES_ACTION_DROP_HEADER = 3;
   */
  DROP_HEADER = 3,
}

/**
 * Describes the enum pomerium.config.HeadersWithUnderscoresAction.
 */
export const HeadersWithUnderscoresActionSchema: GenEnum<HeadersWithUnderscoresAction> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 2);

/**
 * PathWithEscapedSlashesAction determines the action for request that contain
 * %2F, %2f, %5C or %5c sequences in the URI path.
 *
 * @generated from enum pomerium.config.PathWithEscapedSlashesAction
 */
export enum PathWithEscapedSlashesAction {
  /**
   * @generated from enum value: PATH_WITH_ESCAPED_SLASHES_ACTION_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * ⁣Keep escaped slashes.
   *
   * @generated from enum value: PATH_WITH_ESCAPED_SLASHES_ACTION_KEEP_UNCHANGED = 1;
   */
  KEEP_UNCHANGED = 1,

  /**
   * ⁣Reject client request with the 400 status. This is the default behavior.
   *
   * @generated from enum value: PATH_WITH_ESCAPED_SLASHES_ACTION_REJECT_REQUEST = 2;
   */
  REJECT_REQUEST = 2,

  /**
   * Unescape %2F and %5C sequences and redirect request to the new path if
   * these sequences were present.
   *
   * @generated from enum value: PATH_WITH_ESCAPED_SLASHES_ACTION_UNESCAPE_AND_REDIRECT = 3;
   */
  UNESCAPE_AND_REDIRECT = 3,

  /**
   * ⁣Unescape %2F and %5C sequences.
   *
   * @generated from enum value: PATH_WITH_ESCAPED_SLASHES_ACTION_UNESCAPE_AND_FORWARD = 4;
   */
  UNESCAPE_AND_FORWARD = 4,
}

/**
 * Describes the enum pomerium.config.PathWithEscapedSlashesAction.
 */
export const PathWithEscapedSlashesActionSchema: GenEnum<PathWithEscapedSlashesAction> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 3);

/**
 * How the OAuth2 client identifies itself to the authorization server when
 * fetching tokens.
 *
 * @generated from enum pomerium.config.OAuth2AuthStyle
 */
export enum OAuth2AuthStyle {
  /**
   * @generated from enum value: OAUTH2_AUTH_STYLE_UNSPECIFIED = 0;
   */
  OAUTH2_AUTH_STYLE_UNSPECIFIED = 0,

  /**
   * OAUTH2_AUTH_STYLE_IN_PARAMS sends the "client_id" and "client_secret"
   * in the POST body as application/x-www-form-urlencoded parameters.
   *
   * @generated from enum value: OAUTH2_AUTH_STYLE_IN_PARAMS = 1;
   */
  OAUTH2_AUTH_STYLE_IN_PARAMS = 1,

  /**
   * OAUTH2_AUTH_STYLE_IN_HEADER sends the client_id and client_password
   * using HTTP Basic Authorization. This is an optional style
   * described in the OAuth2 RFC 6749 section 2.3.1.
   *
   * @generated from enum value: OAUTH2_AUTH_STYLE_IN_HEADER = 2;
   */
  OAUTH2_AUTH_STYLE_IN_HEADER = 2,
}

/**
 * Describes the enum pomerium.config.OAuth2AuthStyle.
 */
export const OAuth2AuthStyleSchema: GenEnum<OAuth2AuthStyle> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 4);

/**
 * Represents a client certificate enforcement behavior.
 *
 * @generated from enum pomerium.config.MtlsEnforcementMode
 */
export enum MtlsEnforcementMode {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Specifies no default client certificate enforcement: any requirements
   * must be explicitly specified in a policy.
   *
   * @generated from enum value: POLICY = 1;
   */
  POLICY = 1,

  /**
   * Specifies that client certificate requirements will be enforced by
   * route policy, with a default invalid_client_certificate deny rule added
   * to each policy.
   *
   * @generated from enum value: POLICY_WITH_DEFAULT_DENY = 2;
   */
  POLICY_WITH_DEFAULT_DENY = 2,

  /**
   * Specifies that client certificate requirements will be enforced by
   * rejecting any connection attempts without a trusted certificate.
   *
   * @generated from enum value: REJECT_CONNECTION = 3;
   */
  REJECT_CONNECTION = 3,
}

/**
 * Describes the enum pomerium.config.MtlsEnforcementMode.
 */
export const MtlsEnforcementModeSchema: GenEnum<MtlsEnforcementMode> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 5);

/**
 * Indicates where a managed key pair came from.
 *
 * @generated from enum pomerium.config.KeyPairOrigin
 */
export enum KeyPairOrigin {
  /**
   * @generated from enum value: KEY_PAIR_ORIGIN_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * The key pair was uploaded by a user.
   *
   * @generated from enum value: KEY_PAIR_ORIGIN_USER = 1;
   */
  USER = 1,

  /**
   * The key pair was generated by Pomerium itself (e.g. autocert).
   *
   * @generated from enum value: KEY_PAIR_ORIGIN_SYSTEM = 2;
   */
  SYSTEM = 2,
}

/**
 * Describes the enum pomerium.config.KeyPairOrigin.
 */
export const KeyPairOriginSchema: GenEnum<KeyPairOrigin> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 6);

/**
 * Lifecycle state of a managed key pair.
 *
 * @generated from enum pomerium.config.KeyPairStatus
 */
export enum KeyPairStatus {
  /**
   * @generated from enum value: KEY_PAIR_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * The key pair is fully provisioned and ready for use.
   *
   * @generated from enum value: KEY_PAIR_STATUS_READY = 1;
   */
  READY = 1,

  /**
   * The key pair is still being prepared (e.g. waiting on ACME issuance).
   *
   * @generated from enum value: KEY_PAIR_STATUS_PENDING = 2;
   */
  PENDING = 2,
}

/**
 * Describes the enum pomerium.config.KeyPairStatus.
 */
export const KeyPairStatusSchema: GenEnum<KeyPairStatus> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 7);

/**
 * Which Pomerium build is serving the request.
 *
 * @generated from enum pomerium.config.ServerType
 */
export enum ServerType {
  /**
   * @generated from enum value: SERVER_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Pomerium Core (open source).
   *
   * @generated from enum value: SERVER_TYPE_CORE = 1;
   */
  CORE = 1,

  /**
   * Pomerium Enterprise (self-hosted).
   *
   * @generated from enum value: SERVER_TYPE_ENTERPRISE = 2;
   */
  ENTERPRISE = 2,

  /**
   * Pomerium Zero (hosted).
   *
   * @generated from enum value: SERVER_TYPE_ZERO = 3;
   */
  ZERO = 3,
}

/**
 * Describes the enum pomerium.config.ServerType.
 */
export const ServerTypeSchema: GenEnum<ServerType> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 8);

/**
 * CodecType defines the codec type to use for connections.
 *
 * @generated from enum pomerium.config.CodecType
 */
export enum CodecType {
  /**
   * Auto-detect the codec from the client's TLS ALPN advertisement.
   *
   * @generated from enum value: CODEC_TYPE_AUTO = 0;
   */
  AUTO = 0,

  /**
   * Force HTTP/1.1.
   *
   * @generated from enum value: CODEC_TYPE_HTTP1 = 1;
   */
  HTTP1 = 1,

  /**
   * Force HTTP/2.
   *
   * @generated from enum value: CODEC_TYPE_HTTP2 = 2;
   */
  HTTP2 = 2,

  /**
   * Force HTTP/3 (QUIC).
   *
   * @generated from enum value: CODEC_TYPE_HTTP3 = 3;
   */
  HTTP3 = 3,
}

/**
 * Describes the enum pomerium.config.CodecType.
 */
export const CodecTypeSchema: GenEnum<CodecType> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 9);

/**
 * LoadBalancingPolicy defines the strategy used to balance requests across
 * upstream endpoints
 *
 * @generated from enum pomerium.config.LoadBalancingPolicy
 */
export enum LoadBalancingPolicy {
  /**
   * Default load balancing if not specified
   *
   * @generated from enum value: LOAD_BALANCING_POLICY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Classic round robin algorithm
   *
   * @generated from enum value: LOAD_BALANCING_POLICY_ROUND_ROBIN = 1;
   */
  ROUND_ROBIN = 1,

  /**
   * Consistent hashing load balancing
   *
   * @generated from enum value: LOAD_BALANCING_POLICY_MAGLEV = 2;
   */
  MAGLEV = 2,

  /**
   * Random selection of backend
   *
   * @generated from enum value: LOAD_BALANCING_POLICY_RANDOM = 3;
   */
  RANDOM = 3,

  /**
   * Consistent hashing on an attribute
   *
   * @generated from enum value: LOAD_BALANCING_POLICY_RING_HASH = 4;
   */
  RING_HASH = 4,

  /**
   * Select backend with fewest active requests
   *
   * @generated from enum value: LOAD_BALANCING_POLICY_LEAST_REQUEST = 5;
   */
  LEAST_REQUEST = 5,
}

/**
 * Describes the enum pomerium.config.LoadBalancingPolicy.
 */
export const LoadBalancingPolicySchema: GenEnum<LoadBalancingPolicy> = /*@__PURE__*/
  enumDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 10);

/**
 * Manages configuration in Pomerium.
 *
 * @generated from service pomerium.config.ConfigService
 */
export const ConfigService: GenService<{
  /**
   * Creates a new key pair.
   *
   * @generated from rpc pomerium.config.ConfigService.CreateKeyPair
   */
  createKeyPair: {
    methodKind: "unary";
    input: typeof CreateKeyPairRequestSchema;
    output: typeof CreateKeyPairResponseSchema;
  },
  /**
   * Creates a new policy.
   *
   * @generated from rpc pomerium.config.ConfigService.CreatePolicy
   */
  createPolicy: {
    methodKind: "unary";
    input: typeof CreatePolicyRequestSchema;
    output: typeof CreatePolicyResponseSchema;
  },
  /**
   * Creates a new route.
   *
   * @generated from rpc pomerium.config.ConfigService.CreateRoute
   */
  createRoute: {
    methodKind: "unary";
    input: typeof CreateRouteRequestSchema;
    output: typeof CreateRouteResponseSchema;
  },
  /**
   * Creates a new service account.
   *
   * @generated from rpc pomerium.config.ConfigService.CreateServiceAccount
   */
  createServiceAccount: {
    methodKind: "unary";
    input: typeof CreateServiceAccountRequestSchema;
    output: typeof CreateServiceAccountResponseSchema;
  },
  /**
   * Deletes a key pair.
   *
   * @generated from rpc pomerium.config.ConfigService.DeleteKeyPair
   */
  deleteKeyPair: {
    methodKind: "unary";
    input: typeof DeleteKeyPairRequestSchema;
    output: typeof DeleteKeyPairResponseSchema;
  },
  /**
   * Deletes a policy.
   *
   * @generated from rpc pomerium.config.ConfigService.DeletePolicy
   */
  deletePolicy: {
    methodKind: "unary";
    input: typeof DeletePolicyRequestSchema;
    output: typeof DeletePolicyResponseSchema;
  },
  /**
   * Deletes a route.
   *
   * @generated from rpc pomerium.config.ConfigService.DeleteRoute
   */
  deleteRoute: {
    methodKind: "unary";
    input: typeof DeleteRouteRequestSchema;
    output: typeof DeleteRouteResponseSchema;
  },
  /**
   * Deletes a service account.
   *
   * @generated from rpc pomerium.config.ConfigService.DeleteServiceAccount
   */
  deleteServiceAccount: {
    methodKind: "unary";
    input: typeof DeleteServiceAccountRequestSchema;
    output: typeof DeleteServiceAccountResponseSchema;
  },
  /**
   * Gets a key pair.
   *
   * @generated from rpc pomerium.config.ConfigService.GetKeyPair
   */
  getKeyPair: {
    methodKind: "unary";
    input: typeof GetKeyPairRequestSchema;
    output: typeof GetKeyPairResponseSchema;
  },
  /**
   * Gets a policy.
   *
   * @generated from rpc pomerium.config.ConfigService.GetPolicy
   */
  getPolicy: {
    methodKind: "unary";
    input: typeof GetPolicyRequestSchema;
    output: typeof GetPolicyResponseSchema;
  },
  /**
   * Gets a route.
   *
   * @generated from rpc pomerium.config.ConfigService.GetRoute
   */
  getRoute: {
    methodKind: "unary";
    input: typeof GetRouteRequestSchema;
    output: typeof GetRouteResponseSchema;
  },
  /**
   * Gets information about a server.
   *
   * @generated from rpc pomerium.config.ConfigService.GetServerInfo
   */
  getServerInfo: {
    methodKind: "unary";
    input: typeof GetServerInfoRequestSchema;
    output: typeof GetServerInfoResponseSchema;
  },
  /**
   * Gets a service account.
   *
   * @generated from rpc pomerium.config.ConfigService.GetServiceAccount
   */
  getServiceAccount: {
    methodKind: "unary";
    input: typeof GetServiceAccountRequestSchema;
    output: typeof GetServiceAccountResponseSchema;
  },
  /**
   * Gets settings.
   *
   * @generated from rpc pomerium.config.ConfigService.GetSettings
   */
  getSettings: {
    methodKind: "unary";
    input: typeof GetSettingsRequestSchema;
    output: typeof GetSettingsResponseSchema;
  },
  /**
   * Lists all the available log fields.
   *
   * @generated from rpc pomerium.config.ConfigService.ListAvailableLogFields
   */
  listAvailableLogFields: {
    methodKind: "unary";
    input: typeof ListAvailableLogFieldsRequestSchema;
    output: typeof ListAvailableLogFieldsResponseSchema;
  },
  /**
   * Lists key pairs.
   *
   * @generated from rpc pomerium.config.ConfigService.ListKeyPairs
   */
  listKeyPairs: {
    methodKind: "unary";
    input: typeof ListKeyPairsRequestSchema;
    output: typeof ListKeyPairsResponseSchema;
  },
  /**
   * Lists policies.
   *
   * @generated from rpc pomerium.config.ConfigService.ListPolicies
   */
  listPolicies: {
    methodKind: "unary";
    input: typeof ListPoliciesRequestSchema;
    output: typeof ListPoliciesResponseSchema;
  },
  /**
   * Lists routes.
   *
   * @generated from rpc pomerium.config.ConfigService.ListRoutes
   */
  listRoutes: {
    methodKind: "unary";
    input: typeof ListRoutesRequestSchema;
    output: typeof ListRoutesResponseSchema;
  },
  /**
   * Lists service accounts.
   *
   * @generated from rpc pomerium.config.ConfigService.ListServiceAccounts
   */
  listServiceAccounts: {
    methodKind: "unary";
    input: typeof ListServiceAccountsRequestSchema;
    output: typeof ListServiceAccountsResponseSchema;
  },
  /**
   * Lists settings.
   *
   * @generated from rpc pomerium.config.ConfigService.ListSettings
   */
  listSettings: {
    methodKind: "unary";
    input: typeof ListSettingsRequestSchema;
    output: typeof ListSettingsResponseSchema;
  },
  /**
   * Updates an existing key pair.
   *
   * @generated from rpc pomerium.config.ConfigService.UpdateKeyPair
   */
  updateKeyPair: {
    methodKind: "unary";
    input: typeof UpdateKeyPairRequestSchema;
    output: typeof UpdateKeyPairResponseSchema;
  },
  /**
   * Updates an existing policy.
   *
   * @generated from rpc pomerium.config.ConfigService.UpdatePolicy
   */
  updatePolicy: {
    methodKind: "unary";
    input: typeof UpdatePolicyRequestSchema;
    output: typeof UpdatePolicyResponseSchema;
  },
  /**
   * Updates an existing route.
   *
   * @generated from rpc pomerium.config.ConfigService.UpdateRoute
   */
  updateRoute: {
    methodKind: "unary";
    input: typeof UpdateRouteRequestSchema;
    output: typeof UpdateRouteResponseSchema;
  },
  /**
   * Updates an existing service account.
   *
   * @generated from rpc pomerium.config.ConfigService.UpdateServiceAccount
   */
  updateServiceAccount: {
    methodKind: "unary";
    input: typeof UpdateServiceAccountRequestSchema;
    output: typeof UpdateServiceAccountResponseSchema;
  },
  /**
   * Updates existing settings.
   *
   * @generated from rpc pomerium.config.ConfigService.UpdateSettings
   */
  updateSettings: {
    methodKind: "unary";
    input: typeof UpdateSettingsRequestSchema;
    output: typeof UpdateSettingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_github_com_pomerium_pomerium_pkg_grpc_config_config, 0);

